import _possibleConstructorReturn from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v35.6.1 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import e from "@arcgis/core/geometry/Point";
import { d as t, n as s, c as i } from "../index.js";
import a from "lodash";
import r from "@arcgis/core/Graphic";
import o from "@arcgis/core/layers/GraphicsLayer";
import { M as l, L as n, s as h } from "../utils/map.js";
import { Polyline as d, Point as c } from "@arcgis/core/geometry";
import { S as m, J as y, R as u } from "../symbols.js";
import * as p from "@arcgis/core/geometry/geometryEngine";
import f from "@arcgis/core/renderers/UniqueValueRenderer";
import { a8 as g, a9 as b, m as v, aa as L, ab as w, ac as S, ad as F, ae as x, af as _, ag as B, a7 as G, ah as I, ai as O, aj as P, ak as N, al as T, am as V, an as A, ao as R, ap as k, aq as M, ar as E } from "../api/rec.js";
import "uuid";
import J from "@arcgis/core/geometry/SpatialReference";
import "@arcgis/core/tasks/Locator";
import * as D from "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/support/jsonUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";
import C from "@arcgis/core/geometry/Polygon";
import { b as $, G as U, A as q, S as z, L as W, d as H } from "../enums.js";
import j from "@arcgis/core/geometry/Extent";
import K from "@arcgis/core/symbols/SimpleFillSymbol";
import { STATUS as Z, FieldUtils as Y } from "../../helpers/field/index.js";
import { G as X, b as Q } from "../geometry/utils.js";
import ee from "@arcgis/core/layers/WebTileLayer";
import te from "@arcgis/core/layers/support/TileInfo";
import se from "immutable";
import ie from "@arcgis/core/PopupTemplate";
import ae from "fast-deep-equal";
import re from "@arcgis/core/layers/FeatureLayer";
import { a as oe } from "../tslib.es6.js";
import le from "@arcgis/core/layers/Layer";
import ne from "@arcgis/core/views/2d/layers/BaseLayerView2D";
import { property as he, subclass as de } from "@arcgis/core/core/accessorSupport/decorators";
import * as ce from "@arcgis/core/core/watchUtils";
import * as me from "@arcgis/core/core/workers";
import ye from "@arcgis/core/config";

var BaseLayer = /*#__PURE__*/function () {
  function BaseLayer(e, t, s, i) {
    _classCallCheck(this, BaseLayer);

    var a = i.activeMapTool,
        r = i.activeModule,
        o = i.activeToolset,
        l = i.formatMessage,
        n = i.formatNumber,
        h = i.messages,
        d = i.userGuid;
    Object.assign(this, {
      id: e,
      map: t,
      mapView: s,
      activeMapTool: a,
      activeModule: r,
      activeToolset: o,
      formatMessage: l,
      formatNumber: n,
      messages: h,
      options: i,
      userGuid: d
    });
  }

  _createClass(BaseLayer, [{
    key: "clear",
    value: function clear() {
      var _this = this;

      if (this.layer instanceof o) this.layer.removeAll();else if (this.layer instanceof re) return this.layer.queryFeatures({
        returnGeometry: !1
      }).then(function (_ref) {
        var e = _ref.features;
        return _this.layer.applyEdits({
          deleteFeatures: e
        });
      }).catch(function (e) {
        "AbortError" === e.name ? console.warn(e) : console.error(e);
      });
      return Promise.resolve();
    }
  }, {
    key: "_getMaxOffset",
    value: function _getMaxOffset() {
      var e = this.mapView.extent.width / this.mapView.width;
      return e || (e = null), e;
    }
  }, {
    key: "_moveLayerToTop",
    value: function _moveLayerToTop(e) {
      this.mapView.map.reorder(e, this.mapView.map.allLayers.length);
    }
  }, {
    key: "moveLayerToBottom",
    value: function moveLayerToBottom(e) {
      this.mapView.map.reorder(e, 0);
    }
  }, {
    key: "setActiveMapTool",
    value: function setActiveMapTool(e) {
      this.activeMapTool = e;
    }
  }, {
    key: "setActiveModule",
    value: function setActiveModule(e) {
      this.activeModule = e;
    }
  }, {
    key: "setActiveToolset",
    value: function setActiveToolset(e, t) {
      this.activeToolset = e, this.toolsetPayload = t;
    }
  }, {
    key: "setVisibility",
    value: function setVisibility(e) {
      this.layer.visible = e;
    }
  }, {
    key: "zoomToExtent",
    value: function zoomToExtent(e) {
      return this.mapView.extent = e, e;
    }
  }, {
    key: "zoomToFeaturesByGuid",
    value: function () {
      var _zoomToFeaturesByGuid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", g({
                  boundary: e,
                  isActive: !0
                }).then(function (e) {
                  return _this2.zoomToExtent(e);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function zoomToFeaturesByGuid(_x) {
        return _zoomToFeaturesByGuid.apply(this, arguments);
      }

      return zoomToFeaturesByGuid;
    }()
  }]);

  return BaseLayer;
}();

var CanvasLayerSimpleUVR = /*#__PURE__*/function () {
  function CanvasLayerSimpleUVR(e) {
    _classCallCheck(this, CanvasLayerSimpleUVR);

    this.props = e;
  }

  _createClass(CanvasLayerSimpleUVR, [{
    key: "render",
    value: function render(e, t) {
      var _this3 = this;

      var s;
      if (!this.props.canvas || !this.props.map) return;
      var i = this.props.canvas.getContext("2d");
      i.clearRect(0, 0, this.props.canvas.width, this.props.canvas.height);
      var a = document.getElementById(this.props.canvas.id);
      if (a && (a.style.left = "0", a.style.top = "0"), this.props.maxScale && this.props.map.scale < this.props.maxScale) return;
      var r = t || this.props.map.extent,
          o = r.clone(),
          l = o.normalize(),
          n = r.width > o.width;

      if (n) {
        var _e2 = (r.width - o.width) / 2 * this.props.map.width / r.width;

        l.forEach(function (t) {
          t._offset = {
            x: _e2,
            y: 0
          };
        });
      } else if (this.props.map.spatialReference.isWrappable) {
        var _e3 = 0;
        l.forEach(function (t) {
          t._offset = {
            x: _e3,
            y: 0
          }, _e3 += t.width * _this3.props.map.width / o.width;
        });
      }

      var _iterator = _createForOfIteratorHelper(this.props.styles),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _h = _step.value;

          var _t = null !== (s = _h.calc) && void 0 !== s ? s : function () {
            return !0;
          };

          i.fillStyle = _h.fillStyle;

          var _iterator2 = _createForOfIteratorHelper(e),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _s = _step2.value;

              if (_t(_s)) {
                var _iterator3 = _createForOfIteratorHelper(l),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var _e4 = _step3.value;
                    this.renderPoint(_s.geometry, _e4, r, this.props.size, i, n);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "renderPoint",
    value: function renderPoint(t, s, i, a, r, o) {
      var l = a / 2,
          n = s._offset;
      var h = 1 * this.props.map.width * (t.x - s.xmin) / i.width - l + n.x,
          d = 1 * this.props.map.height * (s.ymax - t.y) / i.height - l + n.y;

      if (o) {
        var _s2 = new e(_objectSpread(_objectSpread({}, t), {}, {
          spatialReference: this.props.map.spatialReference
        })),
            _i = this.props.map.toScreen(_s2),
            _a = n.x,
            _r = this.props.map.width - n.x,
            _o = _r - _a;

        h = _i.x < _a ? _r - (_a - _i.x) % _o : _i.x > _r ? _a + (_i.x - _r) % _o : _i.x;
      }

      r.fillRect(h, d, a, a);
    }
  }]);

  return CanvasLayerSimpleUVR;
}();

ye.workers.workerPath = "./workers/RemoteClient.js", ye.workers.loaderUrl = "https://cdn.jsdelivr.net/npm/@dojo/loader@2.0.0/loader.min.js", ye.workers.loaderConfig = {
  paths: {
    layers: new URL("./workers", document.baseURI).href
  }
};

var ue = /*#__PURE__*/function (_le) {
  _inherits(ue, _le);

  var _super = _createSuper(ue);

  function ue(e) {
    var _this4;

    _classCallCheck(this, ue);

    _this4 = _super.call(this, e), _this4.maxScale = 0, _this4.data = [], _this4.view = e.view, _this4.rendererOptions = e.rendererOptions, _this4.maxScale = e.maxScale, _this4._set("type", "canvas");
    return _this4;
  }

  _createClass(ue, [{
    key: "length",
    get: function get() {
      return this.data.length;
    },
    set: function set(e) {
      if (e < 0) throw new Error("Invalid length; must be greater than 0.");
      this._get("length") !== e ? (this._set("length", e), this.data.length = e) : this.notifyChange("length");
    }
  }, {
    key: "createLayerView",
    value: function createLayerView(e) {
      return "2d" === e.type ? Promise.resolve(new fe({
        view: e,
        layer: this
      })) : Promise.reject("View type not supported for this layer.");
    }
  }]);

  return ue;
}(le);

oe([he()], ue.prototype, "rendererOptions", void 0), oe([he()], ue.prototype, "maxScale", void 0), oe([he()], ue.prototype, "filters", void 0), oe([he()], ue.prototype, "importData", void 0), oe([he()], ue.prototype, "activeMapTool", void 0), oe([he()], ue.prototype, "length", null), ue = oe([de("@ai360.core.layers.CanvasLayer")], ue);

var pe = /*#__PURE__*/function (_le2) {
  _inherits(pe, _le2);

  var _super2 = _createSuper(pe);

  function pe(e) {
    var _this5;

    _classCallCheck(this, pe);

    _this5 = _super2.call(this, e), _this5.maxScale = 0, _this5.imageReady = !1, _this5.view = e.view, _this5.imageOptions = e.imageOptions, _this5.maxScale = e.maxScale, _this5.image = new Image(), _this5.image.crossOrigin = "anonymous", _this5.image.onload = function () {
      _this5.imageReady = !0;
    }, _this5.image.src = _this5.imageOptions.url, _this5._set("type", "image");
    return _this5;
  }

  _createClass(pe, [{
    key: "createLayerView",
    value: function createLayerView(e) {
      return "2d" === e.type ? Promise.resolve(new fe({
        view: e,
        layer: this
      })) : Promise.reject("View type not supported for this layer.");
    }
  }]);

  return pe;
}(le);

oe([he()], pe.prototype, "imageOptions", void 0), oe([he()], pe.prototype, "maxScale", void 0), oe([he()], pe.prototype, "activeMapTool", void 0), oe([he()], pe.prototype, "imageReady", void 0), pe = oe([de("@ai360.core.layers.ImageLayer")], pe);

var fe = /*#__PURE__*/function (_ne) {
  _inherits(fe, _ne);

  var _super3 = _createSuper(fe);

  function fe(e) {
    var _this6;

    _classCallCheck(this, fe);

    _this6 = _super3.call(this, e), _this6.offset = {
      x: 0,
      y: 0
    }, _this6.aborted = !1, _this6.ready = !1, _this6.dragging = !1, _this6.requiresRendering = !0, _this6.scaleChange = !1, _this6.processing = !1, _this6.processed = !1, _this6.rendered = !1, _this6.queued = !1, _this6.view = e.view;
    var s = document.createElement("canvas");
    s.style.position = "absolute", s.style.left = "0", s.style.top = "0", _this6.context = s.getContext("2d"), _this6.view.on("drag", function (e) {
      if (0 === e.button && !(e.native.altKey || e.native.ctrlKey || e.native.shiftKey) && null != _this6.layer.activeMapTool) switch (_this6.dragging = !0, e.action) {
        case "start":
          _this6.offset.x = _this6.offset.y = 0;
          break;

        case "update":
          _this6.offset.x = e.x - e.origin.x, _this6.offset.y = e.y - e.origin.y;
          break;

        case "end":
          _this6.dragging = !1;
      }
    }), _this6.view.on("resize", function () {
      _this6.clear();
    }), _this6.view.on("resize", t(function (e) {
      _this6.requiresRendering = !0;
    }, 100)), _this6.view.watch("center", function (e, t) {
      if (e && t && e !== t && !_this6.dragging) {
        var _s3 = _this6.view.toScreen(t),
            _i2 = _this6.view.toScreen(e);

        _this6.offset.x += _s3.x - _i2.x, _this6.offset.y += _s3.y - _i2.y;
      }
    }), _this6.view.watch("stationary", function (e, t) {
      !e && _this6.processing && _this6.controller && !_this6.controller.signal.aborted && (ce.whenTrueOnce(_assertThisInitialized(_this6), "aborted", function () {
        ce.whenTrueOnce(_this6.view, "stationary", _this6.queue.bind(_assertThisInitialized(_this6)));
      }), _this6.abort());
    }), _this6.view.watch("stationary", t(function (e) {
      e && (_this6.requiresRendering = !0);
    }, 500)), _this6.view.watch("scale", function () {
      _this6.scaleChange = _this6.requiresRendering = !0;
    });
    var i = ["rendererOptions", "filters", "importData", "length"],
        a = i.concat(["imageReady"]);
    e.layer.watch(a, function (t, s, a, r) {
      if (t !== s) if (i.includes(a)) {
        switch (a) {
          case "length":
            0 === t && _this6.clear();
            break;

          case "importData":
            var _e5 = r;
            if (_e5.visible !== _e5.importData.showImportPoints) return void (_e5.visible = _e5.importData.showImportPoints);
        }

        _this6.connection && _this6.initPoints(e.layer);
      } else _this6.queue();
    }), ce.whenDefinedOnce(_assertThisInitialized(_this6), "connection", function (t) {
      t && _this6.requiresRendering && !_this6.processing && (_this6.layer.length ? _this6.initPoints(e.layer) : _this6.requestRender());
    }), "canvas" === e.layer.get("type") && me.open("layers/CanvasLayer", {
      strategy: "dedicated"
    }).then(function (e) {
      return _this6.connection = e;
    });
    return _this6;
  }

  _createClass(fe, [{
    key: "render",
    value: function render(e) {
      var t = this.layer.get("type"),
          s = "canvas" === t && this.layer.data.length > 0,
          i = "image" === t && this.layer.imageReady;
      if (!this.layer.visible || this.layer.maxScale && 0 != this.layer.maxScale && e.state.scale < this.layer.maxScale || "image" === t && !i || "canvas" === t && !s) return;
      var a = e.state.pixelRatio || 1;
      !1 === e.stationary && this.scaleChange ? this.clear(e.context.canvas.width, e.context.canvas.height) : (this.requiresRendering && !this.processing && this.process(e, a), e.context.drawImage(this.context.canvas, this.offset.x * a, this.offset.y * a), this.processed && this.rendered && this._set("ready", !0), this.queued = !1);
    }
  }, {
    key: "detach",
    value: function detach() {
      var e;
      _get(_getPrototypeOf(fe.prototype), "detach", this).call(this), this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height), null === (e = this.connection) || void 0 === e || e.close(), this.connection = null;
    }
  }, {
    key: "process",
    value: function process(e, t) {
      var _this7 = this;

      var s = this.layer.get("type");
      if ("canvas" === s && null == this.connection) return;
      var i;
      i = "canvas" === s ? this.renderPoints(this.layer, e.state, t, e.context.canvas.width, e.context.canvas.height) : "image" === s ? this.renderImage(this.layer, t, e.context.canvas.width, e.context.canvas.height) : Promise.resolve(), i.then(this.resetFlags.bind(this)).catch(function (e) {
        "AbortError" === e.name ? (_this7.resetFlags(), _this7.aborted = !0) : console.error(e);
      });
    }
  }, {
    key: "queue",
    value: function queue() {
      this.queued || (this.queued = !0, this.requiresRendering = !0, this.requestRender());
    }
  }, {
    key: "abort",
    value: function abort() {
      this.processing && this.controller && !this.controller.signal.aborted && (this.controller.abort(), this.controller = null, this.processing = !1);
    }
  }, {
    key: "clear",
    value: function clear() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context.canvas.width;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context.canvas.height;
      this.offset.x = this.offset.y = 0, this.context.canvas.width = e, this.context.canvas.height = t;
    }
  }, {
    key: "resetFlags",
    value: function resetFlags() {
      this.scaleChange = this.requiresRendering = this.processing = !1, this._set("updating", !1);
    }
  }, {
    key: "initPoints",
    value: function () {
      var _initPoints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var _this8 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", (this._set("updating", !0), this._set("ready", !1), this.processed = this.rendered = !1, this.connection.invoke("init", {
                  data: e.data,
                  rendererOptions: e.rendererOptions
                }).then(function () {
                  _this8.processed = !0, _this8.queue();
                })));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initPoints(_x2) {
        return _initPoints.apply(this, arguments);
      }

      return initPoints;
    }()
  }, {
    key: "renderPoints",
    value: function () {
      var _renderPoints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, t, s, i, a) {
        var _this9 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", (this.controller = new AbortController(), this.processing = !0, this.aborted = !1, this.connection.invoke("render", {
                  width: i,
                  height: a,
                  viewState: this.view.state.toJSON(),
                  size: e.rendererOptions.size,
                  ratio: s
                }, {
                  signal: this.controller.signal
                }).then(function (e) {
                  _this9.clear(i, a);

                  var t = new ImageData(new Uint8ClampedArray(e), i, a);
                  _this9.context.putImageData(t, 0, 0), _this9.requestRender(), _this9.processed && (_this9.rendered = !0);
                })));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function renderPoints(_x3, _x4, _x5, _x6, _x7) {
        return _renderPoints.apply(this, arguments);
      }

      return renderPoints;
    }()
  }, {
    key: "renderImage",
    value: function () {
      var _renderImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, t, s, i) {
        var a, r, o, l;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                a = this.view.toScreen(e.imageOptions.topLeft), r = this.view.toScreen(e.imageOptions.bottomRight), o = Math.abs(r.x - a.x) * t, l = Math.abs(r.y - a.y) * t;
                return _context4.abrupt("return", (this.clear(s, i), this.context.drawImage(e.image, a.x * t, a.y * t, o, l), this.processed = !0, this.rendered = !0, Promise.resolve()));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function renderImage(_x8, _x9, _x10, _x11) {
        return _renderImage.apply(this, arguments);
      }

      return renderImage;
    }()
  }]);

  return fe;
}(ne);

oe([he()], fe.prototype, "connection", void 0), oe([he()], fe.prototype, "aborted", void 0), oe([he({
  readOnly: !0
})], fe.prototype, "ready", void 0), fe = oe([de("@ai360.core.layers.CanvasGraphicsLayerView")], fe);

var BigDataLayer = /*#__PURE__*/function (_BaseLayer) {
  _inherits(BigDataLayer, _BaseLayer);

  var _super4 = _createSuper(BigDataLayer);

  function BigDataLayer(e, t, s) {
    var _this10;

    _classCallCheck(this, BigDataLayer);

    _this10 = _super4.call(this, e, t.map, t, s), null != s.rendererOptions ? _this10.layer = new ue({
      id: e,
      view: t,
      maxScale: s.maxScale,
      rendererOptions: s.rendererOptions
    }) : null != s.imageOptions && (_this10.layer = new pe({
      id: e,
      view: t,
      maxScale: s.maxScale,
      imageOptions: s.imageOptions
    })), _this10.mapView.map.add(_this10.layer), _this10.mapView.map.reorder(_this10.layer, 0);
    return _this10;
  }

  _createClass(BigDataLayer, [{
    key: "setActiveMapTool",
    value: function setActiveMapTool(e) {
      this.layer.activeMapTool = this.activeMapTool = e;
    }
  }, {
    key: "clear",
    value: function clear() {
      switch (this.layer.get("type")) {
        case "canvas":
          this.layer.length = 0;
          break;

        case "image":
          this.layer.imageReady = !1;
      }

      return Promise.resolve();
    }
  }, {
    key: "getData",
    value: function getData() {
      return "canvas" === this.layer.get("type") ? this.layer.data : [];
    }
  }, {
    key: "setData",
    value: function setData() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      "canvas" === this.layer.get("type") && (this.layer.data = e, this.layer.length = e.length);
    }
  }, {
    key: "setRenderer",
    value: function setRenderer(e) {
      "canvas" === this.layer.get("type") && (e.size || (e.size = 5), e.styles || (e.styles = [{
        fillStyle: "rgba(0,0,255,0.5)",
        color: [0, 0, 255, 127.5]
      }]), this.layer.rendererOptions = _objectSpread({}, e));
    }
  }, {
    key: "setVisibility",
    value: function setVisibility(e) {
      e ? this.show() : this.hide();
    }
  }, {
    key: "show",
    value: function show() {
      this.layer.visible = !0;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.layer.visible = !1;
    }
  }]);

  return BigDataLayer;
}(BaseLayer);

var LegacyCanvasLayer = /*#__PURE__*/function () {
  function LegacyCanvasLayer(e, t, s) {
    _classCallCheck(this, LegacyCanvasLayer);

    this.isVisible = !0, this.data = [], this.dragging = !1, this.options = s, this.map = t.map, this.mapView = t, this.canvas = document.createElement("canvas"), this.canvas.id = e, this.canvas.width = t.width, this.canvas.height = t.height;
    var i = getMapDiv(t);
    i.insertBefore(this.canvas, i.firstChild), this.canvas.style.position = "absolute", this.canvas.style.left = "0", this.canvas.style.top = "0", this._setupRendering(), this._setupListeners();
  }

  _createClass(LegacyCanvasLayer, [{
    key: "_setupListeners",
    value: function _setupListeners() {
      var _this11 = this;

      this.mapView.on("drag", function (e) {
        if (_this11.canvas && 0 === e.button && !(e.native.altKey || e.native.ctrlKey || e.native.shiftKey)) if (_this11.dragging = !0, "update" === e.action) {
          var _t2 = {
            x: e.x - e.origin.x,
            y: e.y - e.origin.y
          };
          _this11.canvas.style.left = "".concat(_t2.x, "px"), _this11.canvas.style.top = "".concat(_t2.y, "px");
        } else "end" === e.action && (_this11.dragging = !1, _this11.render(_this11.getExtent()));
      }), this.mapView.watch("center", function (e, t) {
        e && t && e !== t && !_this11.dragging && _this11.render(_this11.getExtent());
      }), this.mapView.on("resize", function () {
        _this11.render(_this11.getExtent());
      }), this.mapView.watch("scale", function () {
        _this11.canvas && _this11.canvas.getContext("2d").clearRect(0, 0, _this11.canvas.width, _this11.canvas.height);
      });
    }
  }, {
    key: "_setupRendering",
    value: function _setupRendering() {
      var _this12 = this;

      this.options.rendererOptions ? (this._debouncedRender = t(function (e, t) {
        return _this12.renderer.render(e, t);
      }, 100), this.setRenderer(this.options.rendererOptions)) : this.options.imageOptions && (this.img = new Image(), this.img.onload = function () {
        _this12.render();
      }, this.img.src = this.options.imageOptions.url);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.setData([]), this.img = null;
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.isVisible = !1, this.canvas.style.display = "none";
    }
  }, {
    key: "render",
    value: function render(e) {
      this.isVisible && (this.canvas.width = this.mapView.width, this.canvas.height = this.mapView.height, this.img ? this.renderImage() : this._debouncedRender && this._debouncedRender(this.data, e));
    }
  }, {
    key: "renderImage",
    value: function renderImage() {
      if (!this.canvas) return;
      this.canvas.style.left = "0", this.canvas.style.top = "0";
      var e = this.mapView.toScreen(this.options.imageOptions.topLeft),
          t = this.mapView.toScreen(this.options.imageOptions.bottomRight),
          s = Math.abs(t.x - e.x),
          i = Math.abs(t.y - e.y),
          a = this.canvas.getContext("2d");
      a.clearRect(0, 0, this.canvas.width, this.canvas.height), a.drawImage(this.img, e.x, e.y, s, i);
    }
  }, {
    key: "resetPosition",
    value: function resetPosition() {
      if (!this.mapView) {
        var _e6 = getMapDiv(this.mapView);

        _e6 && _e6.lastChild === this.canvas && _e6.insertBefore(this.canvas, document.getElementById(getMapId(this.mapView) + "_gc"));
      }
    }
  }, {
    key: "setData",
    value: function setData() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.data = e, this.render(this.getExtent());
    }
  }, {
    key: "setRenderer",
    value: function setRenderer(e) {
      e.size || (e.size = 5), e.styles || (e.styles = [{
        fillStyle: "rgba(0,0,255,0.5)"
      }]), this.renderer = new CanvasLayerSimpleUVR(_objectSpread(_objectSpread({}, e), {}, {
        canvas: this.canvas,
        map: this.mapView,
        maxScale: this.options.maxScale
      }));
    }
  }, {
    key: "setVisibility",
    value: function setVisibility(e) {
      e ? this.show(!0) : this.hide();
    }
  }, {
    key: "show",
    value: function show() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = !!this.isVisible;
      this.isVisible = !0, this.canvas.style.display = "block", (t || e) && this.render(this.getExtent());
    }
  }, {
    key: "getExtent",
    value: function getExtent() {
      return this.mapView.state && this.mapView.state.extent && this.mapView.state.extent.width !== this.mapView.extent.width ? this.mapView.state.extent : this.mapView.extent;
    }
  }]);

  return LegacyCanvasLayer;
}();

var getMapDiv = function getMapDiv(e) {
  return e.container.querySelector(".esri-view-root > .esri-view-surface");
},
    getMapId = function getMapId(e) {
  return e.container.id;
};

var DggLayer = /*#__PURE__*/function (_BaseLayer2) {
  _inherits(DggLayer, _BaseLayer2);

  var _super5 = _createSuper(DggLayer);

  function DggLayer(e, t, s) {
    var _this13;

    _classCallCheck(this, DggLayer);

    _this13 = _super5.call(this, e, t.map, t, s), _this13.cellGraphic = null, _this13.cellSymbol = m.fromJSON(l.symbols.dgg.mgrsCell), _this13.crosshairGraphic = null, _this13.crosshairLayerId = "".concat(e, "_Crosshair"), _this13.crosshairLayer = new o({
      id: _this13.crosshairLayerId
    }), _this13.crosshairSymbol = m.fromJSON(l.symbols.dgg.crosshair), _this13.polyLayerId = "".concat(e, "_UDPoly"), _this13.polyLayer = new o({
      id: _this13.polyLayerId
    }), _this13.userDefinedPolygonSymbol = m.fromJSON(l.symbols.dgg.userDefined), _this13.userDefinedPolylineSymbol = m.fromJSON(l.symbols.dgg.userDefined), _this13.map && (_this13.map.add(_this13.crosshairLayer), _this13.map.add(_this13.polyLayer)), _this13.clear = _this13.clear.bind(_assertThisInitialized(_this13)), _this13.updateMGRS = _this13.updateMGRS.bind(_assertThisInitialized(_this13));
    return _this13;
  }

  _createClass(DggLayer, [{
    key: "_calculateCrosshairs",
    value: function _calculateCrosshairs(e) {
      var _this$mapView = this.mapView,
          t = _this$mapView.extent,
          s = _this$mapView.spatialReference,
          i = e.extent,
          a = i.center,
          r = [[[t.xmin, a.y], [i.xmin, a.y]], [[t.xmax, a.y], [i.xmax, a.y]], [[a.x, t.ymax], [a.x, i.ymax]], [[a.x, t.ymin], [a.x, i.ymin]]];
      return new d({
        paths: r,
        spatialReference: s
      });
    }
  }, {
    key: "_clearUDPoly",
    value: function _clearUDPoly() {
      this.polyLayer.removeAll();
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.crosshairLayer.removeAll(), this.mgrs = null, this.options.onUpdateMGRS(null), Promise.resolve();
    }
  }, {
    key: "updateMGRS",
    value: function updateMGRS(e, t) {
      if (e !== this.mgrs && (this.mgrs = e, e && t)) {
        var s = new r({
          attributes: {
            mgrs: e
          },
          geometry: t,
          symbol: this.cellSymbol
        });
        this.options.onUpdateMGRS(s), this.updateCrosshairs(s);
      }
    }
  }, {
    key: "updateCrosshairs",
    value: function updateCrosshairs(e) {
      if (this.crosshairLayer.removeMany([this.cellGraphic, this.crosshairGraphic]), this.cellGraphic = null, this.crosshairGraphic = null, e) {
        this.cellGraphic = e.clone();
        var _t3 = this.cellGraphic.geometry;

        if (_t3.extent) {
          var _e7 = this._calculateCrosshairs(_t3);

          this.crosshairGraphic = new r({
            geometry: _e7,
            symbol: this.crosshairSymbol
          }), this.crosshairLayer.addMany([this.cellGraphic, this.crosshairGraphic]), this._moveLayerToTop(this.crosshairLayer);
        }
      }
    }
  }, {
    key: "updateMGRSGroup",
    value: function updateMGRSGroup(e) {
      var t = e.mgrss,
          s = e.polygon;
      a.isEqual(this.mgrss, t) || (this.mgrss = t, this.options.onUpdateMGRSGroup(e), null != t && null != s && this.updateUserDefinedPoly(e));
    }
  }, {
    key: "updateUserDefinedPoly",
    value: function updateUserDefinedPoly(e) {
      var t = e.mgrss,
          s = e.polygon,
          i = e.symbol,
          a = e.attributes;
      null === t && null === s && this._clearUDPoly(), t && s && (this.polyLayer.add(new r({
        attributes: a ? {
          index: a.index
        } : null,
        geometry: s,
        symbol: null === i ? this.userDefinedPolygonSymbol : i
      })), this.polyLayer.visible = !0, this._moveLayerToTop(this.polyLayer));
    }
  }]);

  return DggLayer;
}(BaseLayer);

var ge = {
  name: "isEditing",
  type: "integer"
},
    be = {
  name: "isLargestPolygon",
  type: "integer"
},
    ve = {
  name: "isNameConflict",
  type: "integer"
},
    Le = {
  name: "label",
  type: "string"
},
    we = {
  name: "status",
  type: "integer"
},
    Se = _objectSpread({}, b),
    Fe = "normal",
    xe = "conflicted",
    _e = "duplicate";

var FieldBoundaryImportLayer = /*#__PURE__*/function (_BaseLayer3) {
  _inherits(FieldBoundaryImportLayer, _BaseLayer3);

  var _super6 = _createSuper(FieldBoundaryImportLayer);

  function FieldBoundaryImportLayer(e, t, s) {
    var _this14;

    _classCallCheck(this, FieldBoundaryImportLayer);

    _this14 = _super6.call(this, e, t.map, t, s), _this14.onSelectFields = s.onSelectFields, _this14.importFieldList = s.importFieldList, _this14.ignoreFarm = s.ignoreFarm, _this14.selectedImportFieldIndex = s.selectedImportFieldIndex, _this14.onSetImportFieldBoundaries = s.onSetImportFieldBoundaries, _this14.layer = new o({
      id: e
    }), _this14.focusedLayer = new o({
      id: "".concat(e, "_Focused")
    }), _this14.renderer = new f({
      defaultSymbol: m.fromJSON(l.symbols.importFieldBoundary.normal),
      field: we.name,
      field2: ge.name,
      fieldDelimiter: "|"
    }), _this14.renderer.addUniqueValueInfo("".concat(_e, "|0"), m.fromJSON(l.symbols.importFieldBoundary.conflicted)), _this14.renderer.addUniqueValueInfo("".concat(xe, "|0"), m.fromJSON(l.symbols.importFieldBoundary.conflicted)), _this14.renderer.addUniqueValueInfo("".concat(Fe, "|0"), m.fromJSON(l.symbols.importFieldBoundary.normal)), _this14.renderer.addUniqueValueInfo("".concat(_e, "|1"), m.fromJSON(l.symbols.importFieldBoundary.editing)), _this14.renderer.addUniqueValueInfo("".concat(xe, "|1"), m.fromJSON(l.symbols.importFieldBoundary.editing)), _this14.renderer.addUniqueValueInfo("".concat(Fe, "|1"), m.fromJSON(l.symbols.importFieldBoundary.editing)), t.when(function () {
      t.on("click", function (e) {
        _this14.activeMapTool || _this14.activeToolset !== $.DEFAULT || _this14.select(_this14.mapView.toMap(e));
      });
    }), t.map.layers.add(_this14.layer), t.map.layers.add(_this14.focusedLayer);
    return _this14;
  }

  _createClass(FieldBoundaryImportLayer, [{
    key: "_getLabel",
    value: function _getLabel(e, t) {
      var s = this.options.messages;
      return e ? this.options.formatMessage(s.duplicateBoundary) : t ? this.options.formatMessage(s.duplicateFieldName) : null;
    }
  }, {
    key: "_getStatus",
    value: function _getStatus(e, t) {
      return e ? _e : t ? xe : Fe;
    }
  }, {
    key: "_setFeatures",
    value: function _setFeatures(e, t) {
      var _this15 = this;

      return new Promise(function (i) {
        var a = [];

        var _iterator4 = _createForOfIteratorHelper(e.values()),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _r2 = _step4.value;

            var _e8 = _r2.reduce(function (e, t) {
              var s = n.calculateAcreage(t);
              return s > e.acres ? {
                acres: s,
                graphic: t
              } : e;
            }, {
              acres: -1 / 0,
              graphic: null
            }).graphic;

            var _iterator5 = _createForOfIteratorHelper(_r2),
                _step5;

            try {
              var _loop = function _loop() {
                var i = _step5.value;

                var r = s(i.attributes[Se.importFieldBoundaryGuid]),
                    o = s(i.attributes[Se.customerGuid]),
                    l = t.get(o),
                    n = l.some(function (e) {
                  return (!e.attributes[Se.importFieldBoundaryGuid] || e.attributes[Se.importFieldBoundaryGuid] !== i.attributes[Se.importFieldBoundaryGuid]) && p.equals(i.geometry, e.geometry);
                }),
                    h = !n && l.some(function (e) {
                  return !p.equals(i.geometry, e.geometry) && null != p.intersect(i.geometry, e.geometry);
                }),
                    d = _this15.importFieldList.find(function (e) {
                  return e.importFieldBoundaryGuidList.includes(r);
                }),
                    c = null != d && l.some(function (e) {
                  return void 0 === e.attributes[Se.importFieldBoundaryGuid] && e.attributes.customerGuid === d.customerGuid && (_this15.ignoreFarm || e.attributes[v.farmName] === d.farmName) && e.attributes[v.fieldName] === d.fieldName;
                }),
                    m = null != d && _this15.importFieldList.some(function (e) {
                  return e.customerGuid === d.customerGuid && (_this15.ignoreFarm ? e !== d && e.fieldName === d.fieldName : e !== d && e.farmName === d.farmName && e.fieldName === d.fieldName);
                }),
                    y = c || m,
                    u = i.attributes.calculateAcreage === _e8.attributes.calculateAcreage;

                i.attributes[Se.importFieldBoundaryGuid] = r, i.attributes[we.name] = _this15._getStatus(n, h || y), i.attributes[ge.name] = 0, i.attributes[be.name] = u, i.attributes[ve.name] = y, i.attributes[Le.name] = u ? _this15._getLabel(n, y) : null, a.push(_this15.renderer.getUniqueValueInfo(i).then(function (e) {
                  return i.symbol = e ? e.symbol : _this15.renderer.defaultSymbol, _this15.layer.add(i), i;
                }));
              };

              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        Promise.all(a).then(function (e) {
          var t = _toConsumableArray(e.flat());

          _this15._setLabels(t), i();
        });
      });
    }
  }, {
    key: "_setLabels",
    value: function _setLabels(e) {
      var _this16 = this;

      var t = e.map(function (e) {
        var t = e.geometry.centroid,
            s = m.fromJSON(l.symbols.importFieldBoundary.duplicateBoundaryText);
        return s.text = e.attributes[Le.name], new r({
          geometry: t,
          symbol: s
        });
      }).filter(function (e) {
        return _this16.mapView.extent.intersects(e.geometry) && null !== e.symbol.text;
      });
      t.length > 0 && (this.mapView.graphics.removeMany(this._labels), this._labels = t, this.mapView.graphics.addMany(t));
    }
  }, {
    key: "addSelectedBoundaryGraphics",
    value: function addSelectedBoundaryGraphics(e) {
      var _this17 = this;

      this.clearSelectedBoundaryGraphics(), e.forEach(function (e) {
        _this17.focusedLayer.add(new r({
          geometry: e.geometry.clone(),
          attributes: {},
          symbol: m.fromJSON(l.symbols.importFieldBoundary.selected)
        }));
      });
    }
  }, {
    key: "clearSelectedBoundaryGraphics",
    value: function clearSelectedBoundaryGraphics() {
      this.focusedLayer.removeAll();
    }
  }, {
    key: "getImportFieldBoundaries",
    value: function getImportFieldBoundaries(e) {
      return L(e);
    }
  }, {
    key: "select",
    value: function select(e) {
      var _this18 = this;

      e.type === U.point && (e = p.buffer(e, l.map.clickTolerance * this.mapView.extent.width / this.mapView.width, "meters"));
      var t = "",
          i = new Set();
      if (this.focusedLayer.graphics.some(function (t) {
        return p.intersects(e, t.geometry);
      })) return;
      this.layer.graphics.forEach(function (i) {
        p.intersects(e, i.geometry) && (t = s(i.attributes[Se.importFieldBoundaryGuid]));
      }), this.importFieldList.forEach(function (e) {
        e.importFieldBoundaryGuidList.includes(t) && i.add.apply(i, _toConsumableArray(e.importFieldBoundaryGuidList));
      });
      var a = this.layer.graphics.filter(function (e) {
        return i.has(s(e.attributes[Se.importFieldBoundaryGuid]));
      }).toArray(),
          r = [];

      if (a.forEach(function (e) {
        r.push.apply(r, _toConsumableArray(_this18.layer.graphics.filter(function (t) {
          return i = t, (s = e).attributes[Se.customerGuid] && s.attributes[Se.farmName] ? s.attributes[Se.customerGuid] === i.attributes[Se.customerGuid] && s.attributes[Se.fieldName] === i.attributes[Se.fieldName] && s.attributes[Se.farmName] === i.attributes[Se.farmName] : s.attributes[Se.importFileGuid] === i.attributes[Se.importFileGuid];
          var s, i;
        }).toArray()));
      }), this.onSelectFields && i.size > 0) {
        var _e9 = -1;

        this.importFieldList.forEach(function (t, s) {
          t.importFieldBoundaryGuidList.some(function (e) {
            return i.has(e);
          }) && (_e9 = s);
        }), _e9 !== this.selectedImportFieldIndex ? (this.onSelectFields(_e9), this.addSelectedBoundaryGraphics(r), n.zoomToFeatures(this.mapView, r, l.defaults.extentExpandFactor)) : (this.clearSelectedBoundaryGraphics(), this.onSelectFields(-1));
      }
    }
  }, {
    key: "setIgnoreFarm",
    value: function setIgnoreFarm(e) {
      this.ignoreFarm = e;
    }
  }, {
    key: "processImportFieldBoundaries",
    value: function processImportFieldBoundaries(e, t, i, a) {
      var _this19 = this;

      if (a !== this._lastUpdateStarted) return Promise.resolve();
      var r = new Map(),
          o = new Map(),
          h = [],
          d = this.selectedImportFieldIndex > -1 ? this.importFieldList[this.selectedImportFieldIndex] : null,
          c = d ? d.importFieldBoundaryGuidList : [],
          m = [];

      var _iterator6 = _createForOfIteratorHelper(t),
          _step6;

      try {
        var _loop2 = function _loop2() {
          var l = _step6.value;
          var e = s(l[Se.importFieldBoundaryGuid]),
              t = s(l[Se.customerGuid]);
          var i = -1;
          _this19.importFieldList.forEach(function (t, s) {
            -1 === i && t.importFieldBoundaryGuidList.includes(e) && (i = s);
          }), r.has(i) || r.set(i, []), o.has(t) || o.set(t, []);
          var a = w(l);
          r.set(i, r.get(i).concat(a)), c.includes(e) && m.push(a);
        };

        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return m.length > 0 && i && (this.addSelectedBoundaryGraphics(m), n.zoomToFeatures(this.mapView, m, l.defaults.extentExpandFactor)), o.forEach(function (e, t) {
        h.push(new Promise(function (e, i) {
          S({
            customerGuid: [t],
            isActive: !0,
            returnEmptyArrayIfNoFilters: !0
          }).then(function (i) {
            var a = [];

            for (var _e10 = 0; _e10 < i.length; _e10 += 25) {
              a.push(F(i.slice(_e10, _e10 + 25)));
            }

            Promise.all(a).then(function (i) {
              var a = _toConsumableArray(i.flat()).map(x);

              var _iterator7 = _createForOfIteratorHelper(r.values()),
                  _step7;

              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var _e11 = _step7.value;

                  var _iterator8 = _createForOfIteratorHelper(_e11),
                      _step8;

                  try {
                    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                      var _i3 = _step8.value;
                      s(_i3.attributes[Se.customerGuid]) === t && a.push(_i3);
                    }
                  } catch (err) {
                    _iterator8.e(err);
                  } finally {
                    _iterator8.f();
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }

              o.set(t, a), e();
            });
          });
        }));
      }), Promise.all(h).then(function () {
        _this19.clear(), (e || i && 0 === m.length) && n.zoomToFeatures(_this19.mapView, t.map(w), l.defaults.extentExpandFactor), _this19._setFeatures(r, o).then(function () {
          _this19.onSetImportFieldBoundaries(_this19.layer.graphics.map(function (e) {
            return {
              importFieldBoundaryGuid: e.attributes[Se.importFieldBoundaryGuid],
              shape: JSON.stringify(e.geometry.toJSON()),
              isSpatialConflict: e.attributes[we.name] !== Fe,
              isNameConflict: e.attributes[ve.name]
            };
          }).toArray());
        });
      });
    }
  }, {
    key: "update",
    value: function update(e, t, s) {
      var _this20 = this;

      this._lastUpdateStarted = performance.now();
      var i = this._lastUpdateStarted;
      var a = t.reduce(function (e, t) {
        return e.concat(t.importFieldBoundaryGuidList);
      }, []);
      this.importFieldList = t;
      var r = this.selectedImportFieldIndex !== s;
      return this.selectedImportFieldIndex = s, -1 === this.selectedImportFieldIndex && this.clearSelectedBoundaryGraphics(), this.activeToolset === $.DRAW_EDIT_IMPORT && this.toolsetPayload.importFieldBoundaryGuidList && (a = a.filter(function (e) {
        return !_this20.toolsetPayload.importFieldBoundaryGuidList.includes(e);
      })), 0 === a.length ? (this.clear(), this.mapView.graphics.removeMany(this._labels), Promise.resolve()) : this.getImportFieldBoundaries(a).then(function (t) {
        return _this20.processImportFieldBoundaries(e, t, r, i);
      }).catch(function (e) {
        throw _this20.clear(), e;
      });
    }
  }]);

  return FieldBoundaryImportLayer;
}(BaseLayer);

var Be = {
  name: "hasData",
  type: "integer"
},
    Ge = {
  name: "isLargestPolygon",
  type: "integer"
},
    Ie = {
  name: "isFieldFocus",
  type: "integer"
},
    Oe = {
  name: "status",
  type: "string"
},
    Pe = _objectSpread({}, v),
    Ne = "clearLabels",
    Te = "prepareLabels",
    Ve = "prepareFeatures",
    Ae = "updateLabels";

var FieldBoundaryApiAspect = /*#__PURE__*/function () {
  function FieldBoundaryApiAspect() {
    _classCallCheck(this, FieldBoundaryApiAspect);

    this.previousExtent = null, this.previousAllButExtent = null, this.shouldRemoveFieldBoundaryBeingEdited = null;
  }

  _createClass(FieldBoundaryApiAspect, [{
    key: "attemptFetch",
    value: function attemptFetch(e, t, s) {
      return _(e, t.scale, !0, s);
    }
  }]);

  return FieldBoundaryApiAspect;
}();

var FieldsLayer = /*#__PURE__*/function (_BaseLayer4) {
  _inherits(FieldsLayer, _BaseLayer4);

  var _super7 = _createSuper(FieldsLayer);

  function FieldsLayer(e, t, s, i, a) {
    var _this21$updateWorkerH;

    var _this21;

    _classCallCheck(this, FieldsLayer);

    _this21 = _super7.call(this, e, t, s, i), _this21._fieldController = new AbortController(), _this21._fieldBoundaries = [], _this21._drawTools = [$.DRAW_EDIT, $.DRAW_EDIT_IMPORT], _this21.onSelectFields = i.onSelectFields, _this21.onClearFieldSelection = i.onClearFieldSelection, _this21.onSetSelectedMatchedFieldGuid = i.onSetSelectedMatchedFieldGuid, _this21.selectedMatchedFieldGuid = i.selectedMatchedFieldGuid, _this21.layer = new o({
      id: e
    }), _this21.labels = new o({
      id: "".concat(e, "_Labels")
    }), _this21.focusedLayer = new o({
      id: "".concat(e, "_Focused")
    }), _this21.updateFieldBoundaryLayerInfo(i.fieldBoundaryLayerInfo), _this21.setBackgroundOnly(i.fieldsBackgroundOnly), _this21.setBackgroundOnlyBatch(i.fieldsBackgroundOnlyBatch), _this21.renderer = new f({
      field: Oe.name,
      field2: Ie.name,
      field3: Be.name,
      fieldDelimiter: "|",
      defaultSymbol: m.fromJSON(l.symbols.fields.normal),
      uniqueValueInfos: [{
        value: "".concat(Z.background, "|0|0"),
        symbol: m.fromJSON(l.symbols.fields.background)
      }, {
        value: "".concat(Z.background, "|1|0"),
        symbol: m.fromJSON(l.symbols.fields.transparent)
      }, {
        value: "".concat(Z.background, "|1|1"),
        symbol: m.fromJSON(l.symbols.fields.transparent)
      }, {
        value: "".concat(Z.background, "|1|2"),
        symbol: m.fromJSON(l.symbols.fields.transparent)
      }, {
        value: "".concat(Z.backgroundBatch, "|0|0"),
        symbol: m.fromJSON(l.symbols.fields.background)
      }, {
        value: "".concat(Z.backgroundBatch, "|1|0"),
        symbol: m.fromJSON(l.symbols.fields.transparent)
      }, {
        value: "".concat(Z.backgroundBatch, "|1|1"),
        symbol: m.fromJSON(l.symbols.fields.selected)
      }, {
        value: "".concat(Z.backgroundBatch, "|1|2"),
        symbol: m.fromJSON(l.symbols.fields.selected)
      }, {
        value: "".concat(Z.filtered, "|0|0"),
        symbol: m.fromJSON(l.symbols.fields.filteredOut)
      }, {
        value: "".concat(Z.filtered, "|1|0"),
        symbol: m.fromJSON(l.symbols.fields.transparent)
      }, {
        value: "".concat(Z.filtered, "|1|1"),
        symbol: m.fromJSON(l.symbols.fields.selected)
      }, {
        value: "".concat(Z.filtered, "|1|2"),
        symbol: m.fromJSON(l.symbols.fields.selected)
      }, {
        value: "".concat(Z.normal, "|1|0"),
        symbol: m.fromJSON(l.symbols.fields.transparent)
      }, {
        value: "".concat(Z.normal, "|1|1"),
        symbol: m.fromJSON(l.symbols.fields.selected)
      }, {
        value: "".concat(Z.normal, "|1|2"),
        symbol: m.fromJSON(l.symbols.fields.selected)
      }, {
        value: "".concat(Z.selected, "|0|0"),
        symbol: m.fromJSON(l.symbols.fields.selected)
      }, {
        value: "".concat(Z.selected, "|1|0"),
        symbol: m.fromJSON(l.symbols.fields.transparent)
      }, {
        value: "".concat(Z.selected, "|1|1"),
        symbol: m.fromJSON(l.symbols.fields.selected)
      }, {
        value: "".concat(Z.selected, "|1|2"),
        symbol: m.fromJSON(l.symbols.fields.selected)
      }]
    }), _this21.focusedRenderer = new f({
      field: Be.name,
      defaultSymbol: m.fromJSON(l.symbols.fields.transparent),
      uniqueValueInfos: [{
        value: "1",
        symbol: m.fromJSON(l.symbols.fields.transparent)
      }, {
        value: "2",
        symbol: m.fromJSON(l.symbols.fields.withDataImage)
      }]
    }), _this21.maxScale = l.layers.fields.maxScale, _this21.minScale = l.layers.fields.minScale, _this21.layer.minScale = _this21.minScale, _this21.focusedLayer.minScale = _this21.minScale, _this21.minLabelScale = l.layers.fields.minLabelScale, _this21.labels.minScale = _this21.minLabelScale, _this21.updateWorker = new a(), _this21.updateWorkerHandles = (_this21$updateWorkerH = {}, _defineProperty(_this21$updateWorkerH, Te, _this21._onUpdateWorkerPrepareLabels), _defineProperty(_this21$updateWorkerH, Ve, _this21._onUpdateWorkerPrepareFeatures), _defineProperty(_this21$updateWorkerH, Ae, _this21._onUpdateWorkerPrepareLabels), _this21$updateWorkerH), _this21.updateWorker.addEventListener("message", _this21._onUpdateWorker.bind(_assertThisInitialized(_this21))), _this21._fieldBoundaryApiAspect = new FieldBoundaryApiAspect(), s.when(function () {
      s.on("drag", _this21._drawSelectionBox.bind(_assertThisInitialized(_this21))), s.on("click", function (e) {
        (_this21._isDefaultState() || _this21._isImportState()) && _this21.select(_this21.mapView.toMap(e));
      });
    }), s.map.layers.add(_this21.layer), s.map.layers.add(_this21.focusedLayer), s.map.layers.add(_this21.labels);
    return _this21;
  }

  _createClass(FieldsLayer, [{
    key: "_addFocusedFeature",
    value: function _addFocusedFeature(e, t, s, i) {
      var _this22 = this;

      if (!i || ![$.DEFAULT, $.ZONE_EDIT, $.ZONE_COPY, $.SCOUTING_ZONE_EDIT].includes(this.activeToolset)) return;
      var a = e.attributes[Pe.fieldGuid];

      if (e.attributes[Be.name] = t.has(a) ? 2 : 1, this.activeToolset === $.DEFAULT || a !== s && null != s) {
        var _t4 = new r({
          geometry: e.geometry,
          attributes: e.attributes,
          symbol: new K({
            style: "none"
          })
        });

        this.focusedRenderer.getUniqueValueInfo(_t4).then(function (e) {
          _t4.symbol = e ? e.symbol : _this22.focusedRenderer.defaultSymbol, _this22.focusedLayer.add(_t4);
        });
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      return this.layer.removeAll(), this.focusedLayer.removeAll(), e && (this.labels.removeAll(), this.updateWorker.postMessage({
        type: Ne,
        params: {}
      })), Promise.resolve();
    }
  }, {
    key: "_clearSelectionBox",
    value: function _clearSelectionBox() {
      this.mapView.graphics.removeAll();
    }
  }, {
    key: "_drawSelectionBox",
    value: function _drawSelectionBox(e) {
      var t = this.mapView.toMap(e),
          s = this.mapView.toMap(e.origin);

      switch (e.action) {
        case "update":
          if (!this._isDefaultState()) return;
          (e.native.altKey || e.native.ctrlKey) && (this._clearSelectionBox(), this.mapView.graphics.add(r.fromJSON({
            geometry: C.fromExtent(X.getSelectionArea(s, t)),
            symbol: l.symbols.fields.selectionBox
          })), e.stopPropagation());
          break;

        case "end":
          if (!this._isDefaultState() && !this._isImportState()) return;
          (e.native.altKey || e.native.ctrlKey) && (this.select(C.fromExtent(X.getSelectionArea(s, t)), !0, e.native.altKey), this._clearSelectionBox());
      }
    }
  }, {
    key: "_getIsFocus",
    value: function _getIsFocus(_ref2) {
      var e = _ref2.focusedFieldGuids,
          t = _ref2.normFieldGuid;
      return Y.getIsFocus({
        focusedFieldGuids: e,
        fieldGuid: t
      });
    }
  }, {
    key: "_getStatus",
    value: function _getStatus(_ref3) {
      var e = _ref3.normFieldGuid,
          t = _ref3.selectedFieldGuids,
          s = _ref3.filteredFieldGuids;
      return Y.getStatus({
        activeToolset: this.activeToolset,
        fieldGuid: e,
        fieldsBackgroundOnly: this.fieldsBackgroundOnly,
        fieldsBackgroundOnlyBatch: this.fieldsBackgroundOnlyBatch,
        selectedFieldGuids: t,
        filteredFieldGuids: s
      });
    }
  }, {
    key: "_getToggleStatus",
    value: function _getToggleStatus(e, t, s) {
      var _this23 = this;

      var defaultStatus = function defaultStatus() {
        return _this23.filteredFieldGuids ? _this23.filteredFieldGuids.has(e.attributes[Pe.fieldGuid]) ? Z.normal : Z.filtered : Z.normal;
      };

      return t && !s ? Z.selected : t && s || e.attributes[Oe.name] === Z.selected ? defaultStatus() : Z.selected;
    }
  }, {
    key: "_isDefaultState",
    value: function _isDefaultState() {
      return !this.activeMapTool && this.activeToolset === $.DEFAULT && this.activeModule === q.FIELD;
    }
  }, {
    key: "_isImportState",
    value: function _isImportState() {
      return !this.activeMapTool && this.activeToolset === $.DEFAULT && this.activeModule === q.IMPORT;
    }
  }, {
    key: "_onUpdateWorker",
    value: function _onUpdateWorker(e) {
      if (e && e.data && e.data.type) {
        if (e.data.error) return void console.error(e.data.error);
        this.updateWorkerHandles[e.data.type].call(this, e);
      }
    }
  }, {
    key: "_onUpdateWorkerPrepareFeatures",
    value: function _onUpdateWorkerPrepareFeatures(e) {
      var _this24 = this;

      var _e$data = e.data,
          t = _e$data.fieldMap,
          s = _e$data.fieldGuidHasDataSet,
          i = _e$data.batchFieldGuid,
          a = _e$data.isInBatchWorkflow,
          o = _e$data.isClearLabels,
          l = _e$data.isProcessLabels;

      if (t) {
        (function () {
          var e = [],
              o = [];

          var _iterator9 = _createForOfIteratorHelper(t.entries()),
              _step9;

          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var _step9$value = _slicedToArray(_step9.value, 2),
                  _n = _step9$value[0],
                  _h2 = _step9$value[1];

              var _t5 = {
                fieldGuid: _n,
                features: _h2.map(function (e) {
                  var t = r.fromJSON(e);
                  return t.attributes[Ie.name] && _this24._addFocusedFeature(t, s, i, a), _this24.renderer.getUniqueValueInfo(t).then(function (e) {
                    t.symbol = e ? e.symbol : _this24.renderer.defaultSymbol;
                  }), o.push(t), !!l && e;
                })
              };
              l && e.push(_t5);
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }

          _this24.layer.addMany(o.filter(function (e) {
            return !_this24.layer.graphics.includes(e);
          })), l && _this24._updateFieldLayerLabels(e);
        })();
      }
    }
  }, {
    key: "_onUpdateWorkerPrepareLabels",
    value: function _onUpdateWorkerPrepareLabels(e) {
      var _this25 = this;

      e.data.labels && e.data.labels.forEach(function (e) {
        _this25.labels.add(r.fromJSON(_objectSpread({}, e)));
      });
    }
  }, {
    key: "_updateFieldLayerFeatures",
    value: function () {
      var _updateFieldLayerFeatures2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, t, s, i, a, r, o, l, n, h, d) {
        var _this26 = this,
            _this$_fieldBoundarie;

        var c, m, y, u, p, f;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                c = this._fieldBoundaryApiAspect.shouldRemoveFieldBoundaryBeingEdited && null != d ? d.filter(function (e) {
                  return e.fieldGuid !== _this26.toolsetPayload.fieldGuid;
                }) : d;

                if (!(!c || !i && a !== this._lastUpdateStarted)) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                if (!(0 === c.length)) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return");

              case 5:
                [$.ZONE_EDIT].includes(this.activeToolset) && !this._fieldBoundaryApiAspect.shouldRemoveFieldBoundaryBeingEdited && (this.layer.graphics.removeMany(this.layer.graphics.filter(function (e) {
                  return s.has(e.attributes.fieldGuid);
                })), this._fieldBoundaries = this._fieldBoundaries.filter(function (e) {
                  return !s.has(e.fieldGuid);
                })), this._fieldBoundaryApiAspect.shouldRemoveFieldBoundaryBeingEdited && (this.layer.graphics.removeMany(this.layer.graphics.filter(function (e) {
                  return e.attributes.fieldGuid === _this26.toolsetPayload.fieldGuid;
                })), this._fieldBoundaries = this._fieldBoundaries.filter(function (e) {
                  return e.fieldGuid !== _this26.toolsetPayload.fieldGuid;
                })), this._lastUpdateStatusStarted > a && (t = this._selectedFieldsUpdate, e = this._filteredFieldsUpdate, s = this._focusedFieldsUpdate);
                m = !!(this._lod && r && r.hasOwnProperty("level") && r.level < this._lod);
                this._lod = r && r.hasOwnProperty("level") ? r.level : null;
                y = m || !this._lod, u = new Set(this._fieldBoundaries.map(function (e) {
                  return e.fieldBoundaryPolygonGuid;
                })), p = c.filter(function (e) {
                  return !u.has(e.fieldBoundaryPolygonGuid);
                }), f = p.map(function (e) {
                  return x(e).toJSON();
                });
                _context5.t0 = 0 === this._fieldBoundaries.length;

                if (!_context5.t0) {
                  _context5.next = 13;
                  break;
                }

                _context5.next = 13;
                return this.clear();

              case 13:
                (_this$_fieldBoundarie = this._fieldBoundaries).push.apply(_this$_fieldBoundarie, _toConsumableArray(p));

                this.updateWorker.postMessage({
                  type: Ve,
                  params: {
                    features: f,
                    fields: {
                      customerGuid: Pe.customerGuid,
                      fieldGuid: Pe.fieldGuid,
                      hasData: Be.name,
                      isFieldFocus: Ie.name,
                      status: Oe.name,
                      active: Pe.active
                    },
                    filteredFieldGuids: Array.from(e.keys()),
                    focusedFieldGuids: Array.from(s.keys()),
                    selectedFieldGuids: Array.from(t.keys()),
                    fieldGuidHasDataSet: l,
                    batchFieldGuid: n,
                    isInBatchWorkflow: h,
                    isClearLabels: y,
                    isProcessLabels: o <= this.minLabelScale,
                    activeToolset: this.activeToolset,
                    fieldsBackgroundOnly: this.fieldsBackgroundOnly,
                    fieldsBackgroundOnlyBatch: this.fieldsBackgroundOnlyBatch
                  }
                });

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _updateFieldLayerFeatures(_x12, _x13, _x14, _x15, _x16, _x17, _x18, _x19, _x20, _x21, _x22) {
        return _updateFieldLayerFeatures2.apply(this, arguments);
      }

      return _updateFieldLayerFeatures;
    }()
  }, {
    key: "_updateFieldLayerLabels",
    value: function _updateFieldLayerLabels(e) {
      var t = Te;
      e && e.length && this.updateWorker.postMessage({
        type: t,
        params: {
          fieldBoundaryLayerInfo: this.fieldBoundaryLayerInfo,
          fields: _objectSpread(_objectSpread({}, Pe), {}, {
            hasData: Be.name,
            isFieldFocus: Ie.name,
            isLargestPolygon: Ge.name,
            status: Oe.name
          }),
          labelConfig: l.symbols.fields.labels,
          labelFields: e,
          mapInfo: {
            extent: this.mapView.extent.toJSON(),
            height: this.mapView.height,
            scale: this.mapView.scale,
            width: this.mapView.width
          },
          minLabelScale: this.minLabelScale
        }
      });
    }
  }, {
    key: "forceRedraw",
    value: function forceRedraw(e) {
      if (this.mapView && null != this.mapView.extent) {
        var _t6 = this.mapView.extent.width / this.mapView.width,
            _s4 = e ? _t6 : -1 * _t6;

        this.mapView.extent = new j({
          xmin: this.mapView.extent.xmin + _s4,
          ymin: this.mapView.extent.ymin,
          xmax: this.mapView.extent.xmax + _s4,
          ymax: this.mapView.extent.ymax,
          spatialReference: this.mapView.spatialReference
        });
      }
    }
  }, {
    key: "getSelectedFieldGuids",
    value: function getSelectedFieldGuids() {
      return this._selectedFieldsUpdate;
    }
  }, {
    key: "getFieldBoundary",
    value: function getFieldBoundary(e) {
      return B([e], null, null, !0);
    }
  }, {
    key: "getFieldBoundaries",
    value: function getFieldBoundaries(e) {
      return B(e, null, null, !0);
    }
  }, {
    key: "getFieldBoundaryByBoundaryGuid",
    value: function getFieldBoundaryByBoundaryGuid(e) {
      return F([e], null, null, null);
    }
  }, {
    key: "select",
    value: function select(t) {
      var _this27 = this;

      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

      var a = this._isImportState(),
          r = "point" === t.type ? p.buffer(t, l.map.clickTolerance * this.mapView.extent.width / this.mapView.width, "meters") : t,
          o = new Set(),
          n = new Set();

      this.mapView.scale <= this.minScale ? this.layer.graphics.forEach(function (e) {
        if (!o.has(e.attributes[Pe.fieldGuid]) && !n.has(e.attributes[Pe.fieldGuid]) && p.intersects(t, e.geometry) && (!a || e.attributes[Ie.name])) {
          !(!s || i) || (!s || !i) && !(e.attributes[Oe.name] === Z.selected) ? o.add(e.attributes[Pe.fieldGuid]) : n.add(e.attributes[Pe.fieldGuid]), e.attributes[Oe.name] = _this27._getToggleStatus(e, s, i), _this27.renderer.getUniqueValueInfo(e).then(function (t) {
            e.symbol = t ? t.symbol : _this27.renderer.defaultSymbol;
          });
        }
      }) : null != this.centroidsLayer && (this.centroidsLayer.data.forEach(function (t) {
        o.has(t.attributes.fieldGuid) || !r.contains(new e({
          x: t.geometry.x,
          y: t.geometry.y,
          spatialReference: _this27.mapView.spatialReference
        })) || a && !t.attributes[Ie.name] || (t.attributes.selected = !(!s || i) || (!s || !i) && !t.attributes.selected, t.attributes.selected ? o.add(t.attributes.fieldGuid) : n.add(t.attributes.fieldGuid));
      }), this.centroidsLayer.render()), a || (o.size > 0 && this.onSelectFields && this.onSelectFields(_toConsumableArray(o.values())), n.size > 0 && this.onClearFieldSelection && this.onClearFieldSelection(_toConsumableArray(n.values())));
    }
  }, {
    key: "setBackgroundOnly",
    value: function setBackgroundOnly(e) {
      this.fieldsBackgroundOnly = e;
    }
  }, {
    key: "setBackgroundOnlyBatch",
    value: function setBackgroundOnlyBatch(e) {
      this.fieldsBackgroundOnlyBatch = e;
    }
  }, {
    key: "setCentroidsLayer",
    value: function setCentroidsLayer(e) {
      this.centroidsLayer = e, this.centroidsLayer.setVisibility(this.fieldBoundaryLayerInfo.visible);
    }
  }, {
    key: "update",
    value: function update() {
      var _this28 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = arguments.length > 1 ? arguments[1] : undefined;
      var s = arguments.length > 2 ? arguments[2] : undefined;
      var a = arguments.length > 3 ? arguments[3] : undefined;
      var r = arguments.length > 4 ? arguments[4] : undefined;
      var o = arguments.length > 5 ? arguments[5] : undefined;
      var l = arguments.length > 6 ? arguments[6] : undefined;
      var n = arguments.length > 7 ? arguments[7] : undefined;
      var h = arguments.length > 8 ? arguments[8] : undefined;
      var d = arguments.length > 9 ? arguments[9] : undefined;
      var c = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : !1;
      this.filteredFieldGuids = a, this.selectedMatchedFieldGuid = d, this._fieldController && this._fieldController.abort(), (e || c) && (this._fieldBoundaries.length = 0);
      var m = s ? s.scale : this.mapView.scale,
          y = m > this.minScale,
          u = t || this.mapView.extent;
      if (y || this.mapView.zoom < 11 || u.width > 12e4) return console.warn("Ignoring large extent: ".concat(u.width)), Promise.resolve(void 0);
      var f = this._fieldBoundaryApiAspect.previousExtent,
          g = null !== f && f.width < 12e4 && p.contains(f, u),
          b = g && null !== f ? f : u.clone().expand(2),
          v = this._drawTools.includes(this.activeToolset) && null != this.toolsetPayload.fieldGuid;
      this._fieldBoundaryApiAspect.shouldRemoveFieldBoundaryBeingEdited === v || v || (c = !0), this._fieldBoundaryApiAspect.shouldRemoveFieldBoundaryBeingEdited = v;
      var L = JSON.stringify({
        filteredFieldGuids: a,
        selectedFieldGuids: r,
        focusedFieldGuids: o,
        fieldGuidHasDataSet: l,
        batchFieldGuid: n,
        isInBatchWorkflow: h,
        selectedMatchedFieldGuid: d,
        scale: s ? s.scale : null
      });

      if (!c && g && this._fieldBoundaries.length > 0) {
        if (this._fieldBoundaryApiAspect.previousAllButExtent === L) return Promise.resolve(void 0);
        this._fieldBoundaryApiAspect.previousAllButExtent = L;

        var _e12 = performance.now();

        this._lastUpdateStarted = _e12;

        var _t7 = s ? s.scale : this.mapView.scale;

        return this._updateFieldLayerFeatures(a, r, o, c, _e12, s, _t7, l, n, h, this._fieldBoundaries);
      }

      return this._fieldBoundaryApiAspect.previousExtent = b, this._fieldBoundaryApiAspect.previousAllButExtent = L, i(function () {
        return new Promise(function (e, t) {
          _this28._fieldController = new AbortController();
          var i = performance.now();
          _this28._lastUpdateStarted = i;
          var d = [];
          var y = 5;
          u.width < 25e3 ? y = 2 : u.width <= 6e4 ? y = 3 : u.width <= 8e4 && (y = 4), d.push.apply(d, _toConsumableArray(X.tileExtent(y, y, b)));
          var p = [];

          var _loop3 = function _loop3() {
            var u = _d[_i4];
            p.push(new Promise(function (e, t) {
              _this28._fieldBoundaryApiAspect.attemptFetch(u, _this28.mapView, _this28._fieldController.signal).then(function (e) {
                return _this28._updateFieldLayerFeatures(a, r, o, c, i, s, m, l, n, h, e);
              }).then(function () {
                e();
              }).catch(function (e) {
                t(e);
              });
            }));
          };

          for (var _i4 = 0, _d = d; _i4 < _d.length; _i4++) {
            _loop3();
          }

          Promise.all(p).then(function (t) {
            e();
          }).catch(function (e) {
            "AbortError" !== e.name && (t(e), _this28.clear());
          });
        });
      }, 500).call();
    }
  }, {
    key: "updateFieldBoundaryLayerInfo",
    value: function updateFieldBoundaryLayerInfo(e) {
      var _this29 = this;

      this.fieldBoundaryLayerInfo = e;
      var s = this.fieldBoundaryLayerInfo.visible;
      this.layer.visible = s, this.centroidsLayer && this.centroidsLayer.setVisibility(s), this.mapView.scale <= this.minLabelScale && t(function () {
        var e = {
          type: Ae,
          params: {
            fieldBoundaryLayerInfo: _this29.fieldBoundaryLayerInfo,
            fields: _objectSpread(_objectSpread({}, Pe), {}, {
              hasData: Be.name,
              isFieldFocus: Ie.name,
              isLargestPolygon: Ge.name,
              status: Oe.name
            }),
            labelConfig: l.symbols.fields.labels,
            labelFields: _this29.layer.graphics.map(function (e) {
              return e.toJSON();
            }),
            updateExisting: !0
          }
        };
        _this29.labels.graphics.length ? (_this29.labels.removeAll(), _this29.updateWorker.postMessage(e)) : _this29.updateWorker.postMessage(_objectSpread(_objectSpread({}, e), {}, {
          mapInfo: {
            extent: _this29.mapView.extent,
            height: _this29.mapView.height,
            scale: _this29.mapView.scale,
            width: _this29.mapView.width
          },
          minLabelScale: _this29.minLabelScale,
          updateExisting: !1
        }));
      }, 500)(), this.labels.visible = s;
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(e, t, s, i, a, r) {
      var _this30 = this;

      return this._selectedFieldsUpdate = t, this._filteredFieldsUpdate = this.filteredFieldGuids = e, this._focusedFieldsUpdate = s, this._lastUpdateStatusStarted = performance.now(), this.focusedLayer.graphics.removeAll(), this.layer.graphics.forEach(function (o) {
        var l = o.attributes[Pe.fieldGuid],
            n = _this30._getIsFocus({
          focusedFieldGuids: s,
          normFieldGuid: l
        });

        o.attributes[Oe.name] = _this30._getStatus({
          normFieldGuid: l,
          selectedFieldGuids: t,
          filteredFieldGuids: e
        }), o.attributes[Ie.name] = n, o.attributes[Be.name] = 0, n && _this30._addFocusedFeature(o, i, a, r), _this30.renderer.getUniqueValueInfo(o).then(function (e) {
          o.symbol = e ? e.symbol : _this30.renderer.defaultSymbol;
        });
      }), Promise.resolve();
    }
  }, {
    key: "zoomToCustomer",
    value: function zoomToCustomer(e) {
      var _this31 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return new Promise(function (s, i) {
        if (t && null == e) return void s(null);
        var a = g({
          customer: [e],
          isActive: !0
        }),
            r = null == _this31.getCustomer ? Promise.resolve(null) : _this31.getCustomer(e);
        Promise.all([a, r]).then(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              e = _ref5[0],
              a = _ref5[1];

          if (null != e || null == _this31.getCustomer) {
            var _t8 = _this31.zoomToExtent(e);

            return void s(_t8);
          }

          if (null == a) return void (t ? s(null) : i("No customer found"));
          var r = a.city,
              o = a.state,
              l = a.zipCode,
              n = "".concat(r, ", ").concat(o, ", ").concat(l);
          G.findAddress(n, _this31.mapView.spatialReference).then(function (e) {
            if (e.length > 0) {
              var _t9 = e[0].extent;
              _this31.mapView.extent = _t9, s(_t9);
            } else i("No matching address candidates found");
          });
        });
      });
    }
  }, {
    key: "zoomToFarm",
    value: function () {
      var _zoomToFarm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e, t) {
        var s;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return g({
                  customer: [e],
                  farm: [t],
                  isActive: !0
                });

              case 2:
                s = _context6.sent;
                return _context6.abrupt("return", this.zoomToExtent(s));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function zoomToFarm(_x23, _x24) {
        return _zoomToFarm.apply(this, arguments);
      }

      return zoomToFarm;
    }()
  }, {
    key: "zoomToField",
    value: function zoomToField(e) {
      var _this32 = this;

      return g({
        field: [e],
        isActive: !0
      }).then(function (e) {
        return _this32.zoomToExtent(e);
      });
    }
  }, {
    key: "zoomToFields",
    value: function zoomToFields(e) {
      var _this33 = this;

      return g({
        field: e,
        isActive: !0
      }).then(function (e) {
        return _this33.zoomToExtent(e);
      });
    }
  }]);

  return FieldsLayer;
}(BaseLayer);

var Re = "imagery";

var ImportDataConvexHullLayer = /*#__PURE__*/function (_BaseLayer5) {
  _inherits(ImportDataConvexHullLayer, _BaseLayer5);

  var _super8 = _createSuper(ImportDataConvexHullLayer);

  function ImportDataConvexHullLayer(e, t, s) {
    var _this34;

    _classCallCheck(this, ImportDataConvexHullLayer);

    _this34 = _super8.call(this, e, t.map, t, s), _this34.convexHulls = {}, _this34.importFileGuidList = s.importFileGuidList, _this34.filteredFieldImportFileList = s.filteredFieldImportFileList, _this34.userGuid = s.userGuid, _this34.selectedMatchedFieldGuid = s.selectedMatchedFieldGuid, _this34.layer = new o({
      id: e
    }), _this34.map.add(_this34.layer);
    return _this34;
  }

  _createClass(ImportDataConvexHullLayer, [{
    key: "update",
    value: function update(e, t, s, i, a, o) {
      var h = JSON.stringify(this.importFileGuidList) !== JSON.stringify(s) || JSON.stringify(this.filteredFieldImportFileList) !== JSON.stringify(i) || JSON.stringify(this.convexHulls) !== JSON.stringify(t);
      if (!h) return Promise.resolve();
      if (this.convexHulls = t, this.importFileGuidList = s, this.filteredFieldImportFileList = i, this.clear(), 0 === s.length) return this.filteredFieldImportFileList.length = 0, this.convexHulls = {}, Promise.resolve();
      var d = [];

      if (s.forEach(function (e) {
        t[e] && d.push(X.wktToGeometry(t[e]));
      }), d.length > 0) {
        var _t10 = o && o.name.toLowerCase() === Re,
            _s5 = p.convexHull(d, !0),
            _i5 = new r({
          geometry: _s5[0],
          attributes: {},
          symbol: m.fromJSON(l.symbols.importDataConvexHull)
        });

        _t10 || this.layer.add(_i5), (e || h || this.selectedMatchedFieldGuid !== a && !a) && n.zoomToFeatures(this.mapView, [_i5], l.defaults.extentExpandFactor), this.selectedMatchedFieldGuid = a;
      }

      return Promise.resolve();
    }
  }]);

  return ImportDataConvexHullLayer;
}(BaseLayer);

var ImageryTileLayer = /*#__PURE__*/function (_ee) {
  _inherits(ImageryTileLayer, _ee);

  var _super9 = _createSuper(ImageryTileLayer);

  function ImageryTileLayer(e, t) {
    var _this35;

    _classCallCheck(this, ImageryTileLayer);

    _this35 = _super9.call(this), _this35.getTileUrl = function (e, t, s) {
      if (!this.imageryTileBucketName || "00000000-0000-0000-0000-000000000000" === this.imageryLayerGuid) return null;
      var i = ImageryTileLayer.getNormalizedCoord({
        x: s,
        y: t
      }, e);
      if (!i) return null;
      var a = Math.pow(2, e);
      return "https://".concat(this.imageryTileBucketName, ".s3.amazonaws.com/").concat(this.imageryLayerGuid, "/").concat(e, "/").concat(i.x, "/").concat(a - i.y - 1, ".png");
    }, _this35.urlTemplate = "https://".concat(t, ".s3.amazonaws.com/").concat(e, "/{level}/{col}/{row}"), _this35.tileInfo = new te({
      size: [256, 256],
      dpi: 72,
      format: "png32",
      spatialReference: {
        wkid: 3857
      },
      lods: l.lods,
      origin: {
        x: -20037508.342787,
        y: 20037508.342787
      }
    }), _this35.imageryLayerGuid = e, _this35.imageryTileBucketName = t, _this35._set("spatialReference", new J({
      wkid: 3857
    }));
    return _this35;
  }

  return ImageryTileLayer;
}(ee);

ImageryTileLayer.getNormalizedCoord = function (e, t) {
  var s = e.y,
      i = e.x,
      a = 1 << t;
  return s < 0 || s >= a ? null : ((i < 0 || i >= a) && (i = (i % a + a) % a), {
    x: i,
    y: s
  });
}, ImageryTileLayer.prototype.declaredClass = "ImageryTileLayer";

var TileLayer = /*#__PURE__*/function (_BaseLayer6) {
  _inherits(TileLayer, _BaseLayer6);

  var _super10 = _createSuper(TileLayer);

  function TileLayer(e, t, s) {
    var _this36;

    _classCallCheck(this, TileLayer);

    _this36 = _super10.call(this, e, t.map, t, s), _this36.imageryLayerGuid = s.imageryLayerGuid, _this36.imageryTileBucketName = s.imageryTileBucketName, _this36.layerId = e, _this36.imageryLayerGuid && "00000000-0000-0000-0000-000000000000" !== _this36.imageryLayerGuid && _this36.imageryTileBucketName && (_this36.layer = new ImageryTileLayer(_this36.imageryLayerGuid, _this36.imageryTileBucketName), _this36.layer.id = _this36.layerId, _this36.layer.name = _this36.layerId, _this36.map.layers.add(_this36.layer), _this36.layer.visible = !0);
    return _this36;
  }

  _createClass(TileLayer, [{
    key: "hide",
    value: function hide() {
      this.layer && (this.layer.visible = !1);
    }
  }, {
    key: "show",
    value: function show() {
      this.layer && (this.layer.visible = !0);
    }
  }, {
    key: "update",
    value: function update(e) {
      return this.imageryLayerGuid = e, this.layer && this.map.layers.remove(this.layer), this.layer = new ImageryTileLayer(e, this.imageryTileBucketName), this.layer.id = this.layerId, this.layer.name = this.layerId, this.map.layers.add(this.layer), this.layer.visible = !0, this.mapView.whenLayerView(this.layer);
    }
  }]);

  return TileLayer;
}(BaseLayer);

var MultiFieldImageryLayer = /*#__PURE__*/function (_BaseLayer7) {
  _inherits(MultiFieldImageryLayer, _BaseLayer7);

  var _super11 = _createSuper(MultiFieldImageryLayer);

  function MultiFieldImageryLayer(e, t, s) {
    var _this37;

    _classCallCheck(this, MultiFieldImageryLayer);

    _this37 = _super11.call(this, e, t.map, t, s), _this37.layerImagery = new Map(), _this37.imageryLayerGuids = s.multiFieldImageryLayerGuids, _this37.extent = t.fullExtent || t.extent, _this37.imageryTileBucketName = s.imageryTileBucketName, _this37.imageryLayerGuids.forEach(function (s) {
      var i = new TileLayer("".concat(e, "-").concat(s), t, _objectSpread(_objectSpread({}, _this37.options), {}, {
        imageryTileBucketName: _this37.imageryTileBucketName,
        imageryLayerGuid: s
      }));

      _this37.layerImagery.set(s, i);
    });
    return _this37;
  }

  return MultiFieldImageryLayer;
}(BaseLayer);

var MultiLayer = /*#__PURE__*/function (_BaseLayer8) {
  _inherits(MultiLayer, _BaseLayer8);

  var _super12 = _createSuper(MultiLayer);

  function MultiLayer(e, t, s, i) {
    var _this38;

    _classCallCheck(this, MultiLayer);

    _this38 = _super12.call(this, e, t.map, t, s), _this38.storedLayers = i.map(function (t) {
      return new StoredLayer(e, t);
    });

    var _iterator10 = _createForOfIteratorHelper(_this38.storedLayers),
        _step10;

    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var _a2 = _step10.value;
        _this38.map && _a2.addLayersTo(_this38.map);
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }

    return _this38;
  }

  _createClass(MultiLayer, [{
    key: "setData",
    value: function setData(e) {
      var _iterator11 = _createForOfIteratorHelper(this.storedLayers),
          _step11;

      try {
        var _loop4 = function _loop4() {
          var t = _step11.value;
          var s = e.find(function (e) {
            return e.name === t.name;
          }),
              i = s ? s.values : [];
          t.setData(i);
        };

        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          _loop4();
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
  }, {
    key: "updateLayerInfos",
    value: function updateLayerInfos(e) {
      var _iterator12 = _createForOfIteratorHelper(this.storedLayers),
          _step12;

      try {
        var _loop5 = function _loop5() {
          var t = _step12.value;
          var s = e.find(function (e) {
            return e.name === t.name;
          }),
              i = s || MultiLayer.createDefaultLayerInfo(t.name);
          t.updateLayerInfo(i);
        };

        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          _loop5();
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }
  }, {
    key: "show",
    value: function show() {
      var _iterator13 = _createForOfIteratorHelper(this.storedLayers),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _e13 = _step13.value;

          _e13.show();
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var _iterator14 = _createForOfIteratorHelper(this.storedLayers),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var _e14 = _step14.value;

          _e14.hide();
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }
  }, {
    key: "allVisible",
    value: function allVisible() {
      var _this39 = this;

      return this.storedLayers.filter(function (e) {
        return e.isVisible(_this39.mapView);
      }).map(function (e) {
        return e.name;
      });
    }
  }], [{
    key: "createDefaultLayerInfo",
    value: function createDefaultLayerInfo(e) {
      return Object.freeze({
        name: e,
        visible: !1,
        showLabels: !0
      });
    }
  }]);

  return MultiLayer;
}(BaseLayer);

var StoredLayer = /*#__PURE__*/function () {
  function StoredLayer(e, t) {
    _classCallCheck(this, StoredLayer);

    this.name = t.name, this.toShape = t.toShape, this.toGraphicAttributes = t.toGraphicAttributes, this.items = t.items.map(function (s, i) {
      return new StoredItem("".concat(e, "_").concat(t.name, "_").concat(i), s);
    });
  }

  _createClass(StoredLayer, [{
    key: "addLayersTo",
    value: function addLayersTo(e) {
      e.layers.addMany(this.items.flatMap(function (e) {
        return e.allGraphicsLayers;
      }));
    }
  }, {
    key: "setData",
    value: function setData(e) {
      var _this40 = this;

      var attemptAddGraphicsTo = function attemptAddGraphicsTo(t, s) {
        if (!t) return;
        var i = e.map(function (e) {
          var t = _this40.toShape(e),
              i = _this40.toGraphicAttributes(e);

          return s(t, i);
        }).filter(function (e) {
          return !t.graphics.some(function (t) {
            return t.attributes.key === e.attributes.key;
          });
        });
        t.addMany(i);
      };

      var _iterator15 = _createForOfIteratorHelper(this.items),
          _step15;

      try {
        var _loop6 = function _loop6() {
          var t = _step15.value;
          attemptAddGraphicsTo(t.geometryLayer, function (e, s) {
            var i = m.fromJSON(t.geometrySymbolJSON);
            return new r({
              geometry: e,
              attributes: s,
              symbol: i
            });
          }), attemptAddGraphicsTo(t.textLayer, function (e, s) {
            var i = e.centroid,
                a = m.fromJSON(t.textSymbolJSON);
            return a.text = t.textExtractor(s), new r({
              geometry: i,
              symbol: a,
              attributes: s
            });
          });
        };

        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          _loop6();
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
    }
  }, {
    key: "updateLayerInfo",
    value: function updateLayerInfo(e) {
      var attemptChangeVisibility = function attemptChangeVisibility(e, t) {
        e && (e.visible = !!t);
      };

      var _iterator16 = _createForOfIteratorHelper(this.items),
          _step16;

      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var _t11 = _step16.value;
          attemptChangeVisibility(_t11.geometryLayer, e.visible), attemptChangeVisibility(_t11.textLayer, e.visible && e.showLabels);
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
    }
  }, {
    key: "show",
    value: function show() {
      var _iterator17 = _createForOfIteratorHelper(this.items),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _e15 = _step17.value;

          var _iterator18 = _createForOfIteratorHelper(_e15.allGraphicsLayers),
              _step18;

          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var _t12 = _step18.value;
              _t12.visible = !0;
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var _iterator19 = _createForOfIteratorHelper(this.items),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _e16 = _step19.value;

          var _iterator20 = _createForOfIteratorHelper(_e16.allGraphicsLayers),
              _step20;

          try {
            for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
              var _t13 = _step20.value;
              _t13.visible = !1;
            }
          } catch (err) {
            _iterator20.e(err);
          } finally {
            _iterator20.f();
          }
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
    }
  }, {
    key: "isVisible",
    value: function isVisible(e) {
      return this.items.some(function (t) {
        return t.allGraphicsLayers.some(function (t) {
          var s = e.scale;
          return t.visible && (t.minScale <= s || t.maxScale >= s);
        });
      });
    }
  }]);

  return StoredLayer;
}();

var StoredItem = function StoredItem(e, t) {
  _classCallCheck(this, StoredItem);

  this.geometryLayer = null, this.textLayer = null;

  var optionalScaleToEsri = function optionalScaleToEsri(e) {
    return e || 0;
  };

  t.geometry && (this.geometryLayer = new o({
    id: "".concat(e, "_Geometry"),
    visible: !1,
    minScale: optionalScaleToEsri(t.geometry.minScale),
    maxScale: optionalScaleToEsri(t.geometry.maxScale)
  }), this.geometrySymbolJSON = t.geometry.symbol), t.text && (this.textLayer = function (t, s) {
    var i = new o();
    return i.id = "".concat(e, "_").concat(t), i.visible = !1, i.minScale = optionalScaleToEsri(s.minScale), i.maxScale = optionalScaleToEsri(s.maxScale), i;
  }("Text", t.text), this.textSymbolJSON = t.text.symbol, this.textExtractor = t.text.textExtractor), this.allGraphicsLayers = [this.geometryLayer, this.textLayer].filter(function (e) {
    return e;
  });
};

var NonFieldFeaturesLayer = /*#__PURE__*/function (_BaseLayer9) {
  _inherits(NonFieldFeaturesLayer, _BaseLayer9);

  var _super13 = _createSuper(NonFieldFeaturesLayer);

  function NonFieldFeaturesLayer(e, t, s) {
    var _this41;

    _classCallCheck(this, NonFieldFeaturesLayer);

    _this41 = _super13.call(this, e, t.map, t, s), _this41.allLayers = [], _this41.features = se.Set(), _this41.highlightedFeatures = se.Set(), _this41.polygonLayer = new o({
      id: "".concat(e, "_Polygons"),
      minScale: l.layers.fields.minScale,
      graphics: []
    }), _this41.allLayers.push(_this41.polygonLayer), _this41.mapView.map.layers.add(_this41.polygonLayer), _this41.polylineLayer = new o({
      id: "".concat(e, "_Polylines"),
      minScale: l.layers.fields.minScale,
      graphics: []
    }), _this41.allLayers.push(_this41.polylineLayer), _this41.mapView.map.layers.add(_this41.polylineLayer), _this41.symbolPolygon = m.fromJSON(l.symbols.nonFieldFeatures.polygon), _this41.symbolPolygonHighlight = m.fromJSON(l.symbols.nonFieldFeatures.highlighted.polygon), _this41.symbolPoint = m.fromJSON(l.symbols.nonFieldFeatures.point), _this41.symbolPointHighlight = m.fromJSON(l.symbols.nonFieldFeatures.highlighted.point), _this41.symbolPolyline = m.fromJSON(l.symbols.nonFieldFeatures.polyline), _this41.symbolPolylineHighlight = m.fromJSON(l.symbols.nonFieldFeatures.highlighted.polyline), _this41.pointLayer = new o({
      id: "".concat(e, "_Points"),
      minScale: l.layers.fields.minScale,
      graphics: []
    }), _this41.allLayers.push(_this41.pointLayer), _this41.mapView.map.layers.add(_this41.pointLayer), _this41.labelLayer = new o({
      id: "".concat(_this41.id, "_labels"),
      minScale: l.layers.fields.minScale,
      graphics: []
    }), _this41.allLayers.push(_this41.labelLayer), _this41.mapView.map.layers.add(_this41.labelLayer);
    return _this41;
  }

  _createClass(NonFieldFeaturesLayer, [{
    key: "setLabels",
    value: function setLabels(t) {
      this.labelLayer.removeAll();
      var s = t.map(function (t) {
        var s = m.fromJSON(l.symbols.nonFieldFeatures.label);
        var i;
        if (s.text = t.attributes.name, "polygon" === t.geometry.type) i = t.geometry.centroid;else if ("polyline" === t.geometry.type) {
          var _s6 = t.geometry.getPoint(0, 0),
              _a3 = t.geometry.getPoint(0, 1);

          i = new e({
            x: _s6.x + (_a3.x - _s6.x) / 2,
            y: _s6.y + (_a3.y - _s6.y) / 2,
            spatialReference: t.geometry.spatialReference
          });
        } else i = t.geometry;
        return new r({
          geometry: i,
          symbol: s
        });
      });
      this.labelLayer.addMany(s);
    }
  }, {
    key: "setFeatures",
    value: function setFeatures(e) {
      var _this42 = this;

      if (a.isEqual(a.sortBy(e), a.sortBy(this.features))) return;
      this.features = e, this.clear();
      if (0 === e.flatMap(function (e) {
        return e.geometries.map(function (t) {
          return {
            feature: e,
            geometry: t
          };
        });
      }).size) return;
      var t = this.features.flatMap(function (e) {
        return e.geometries.map(function (t) {
          return {
            feature: e,
            geometry: t
          };
        });
      }).map(function (e) {
        return _this42._graphicFromGeometry(e.geometry, e.feature);
      });
      this.polygonLayer.addMany(t.filter(function (e) {
        return "polygon" === e.geometry.type;
      }).toArray()), this.pointLayer.addMany(t.filter(function (e) {
        return "point" === e.geometry.type;
      }).toArray()), this.polylineLayer.addMany(t.filter(function (e) {
        return "polyline" === e.geometry.type;
      }).toArray()), this.setLabels(t.toArray());
    }
  }, {
    key: "setHighlighted",
    value: function setHighlighted(e) {
      this._dehighlightAll();

      var _iterator21 = _createForOfIteratorHelper(e),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var _t14 = _step21.value;

          this._highlightFeature(_t14);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    }
  }, {
    key: "setCanShowTooltip",
    value: function setCanShowTooltip(e) {}
  }, {
    key: "clear",
    value: function clear() {
      var _this43 = this;

      return new Promise(function (e, t) {
        var s = _this43.allLayers.map(function (e) {
          return e.graphics.removeAll();
        });

        Promise.all(s).then(function () {
          return e();
        });
      });
    }
  }, {
    key: "show",
    value: function show() {
      var _iterator22 = _createForOfIteratorHelper(this.allLayers),
          _step22;

      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var _e17 = _step22.value;
          _e17.visible = !0;
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var _iterator23 = _createForOfIteratorHelper(this.allLayers),
          _step23;

      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var _e18 = _step23.value;
          _e18.visible = !1;
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
    }
  }, {
    key: "zoomToFeatures",
    value: function zoomToFeatures(e) {
      var t = e.flatMap(function (e) {
        return e.geometries;
      }).map(function (e) {
        return e.shape;
      });

      if (t.length > 0) {
        var _e19 = X.calculateExtent(t);

        this.mapView.extent = _e19;
      }
    }
  }, {
    key: "_getSymbol",
    value: function _getSymbol(e, t) {
      return "point" === e ? 1 === t ? this.symbolPointHighlight : this.symbolPoint : "polyline" === e ? 1 === t ? this.symbolPolylineHighlight : this.symbolPolyline : 1 === t ? this.symbolPolygonHighlight : this.symbolPolygon;
    }
  }, {
    key: "_setSymbols",
    value: function _setSymbols(e, t, s, i) {
      (i ? e.graphics.filter(function (e) {
        return e.attributes.id === i;
      }) : e.graphics).forEach(function (e) {
        e.attributes.highlighted = s, e.symbol = t;
      });
    }
  }, {
    key: "_highlightFeature",
    value: function _highlightFeature(e) {
      this._setSymbols(this.polygonLayer, this.symbolPolygonHighlight, 1, e.id), this._setSymbols(this.pointLayer, this.symbolPointHighlight, 1, e.id), this._setSymbols(this.polylineLayer, this.symbolPolylineHighlight, 1, e.id), this.highlightedFeatures.add(e);
    }
  }, {
    key: "_dehighlightAll",
    value: function _dehighlightAll() {
      this._setSymbols(this.polygonLayer, this.symbolPolygon, 0), this._setSymbols(this.pointLayer, this.symbolPoint, 0), this._setSymbols(this.polylineLayer, this.symbolPolyline, 0), this.highlightedFeatures = se.Set();
    }
  }, {
    key: "_graphicFromGeometry",
    value: function _graphicFromGeometry(e, t) {
      var s = this.highlightedFeatures.some(function (e) {
        return e.id === t.id;
      }) ? 1 : 0,
          i = this._getSymbol(e.shape.type, s),
          a = new ie({
        title: "{name}",
        content: function content(_ref6) {
          var e = _ref6.graphic;
          var t = "Type: ".concat(e.attributes.type, "<br><br>Grower: ").concat(e.attributes.customerName);
          return e.attributes.description && t.concat("<br><hr>Description: ".concat(e.attributes.description)), t;
        }
      });

      return new r({
        geometry: e.shape,
        attributes: {
          id: t.id,
          customerName: t.customerName,
          name: t.name,
          type: t.type,
          description: t.description,
          highlighted: s,
          symbol: i
        },
        popupTemplate: a
      });
    }
  }]);

  return NonFieldFeaturesLayer;
}(BaseLayer);

var ke = ["classId", "Class"],
    Me = {
  name: "class",
  alias: "class",
  type: "integer"
};

var PolygonLayer = /*#__PURE__*/function (_BaseLayer10) {
  _inherits(PolygonLayer, _BaseLayer10);

  var _super14 = _createSuper(PolygonLayer);

  function PolygonLayer(e, t, s) {
    var _this44;

    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, PolygonLayer);

    _this44 = _super14.call(this, e, t.map, t, s), _this44.layerPromises = [];
    var a = PolygonLayer.featuresToPolygonFeatureGraphics(i),
        d = new f({
      field: Me.name,
      defaultSymbol: m.fromJSON(s.symbols.default)
    });

    var _iterator24 = _createForOfIteratorHelper(s.classBreaks || []),
        _step24;

    try {
      for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
        var _r3 = _step24.value;

        var _r3$color = _r3.color,
            _e21 = _r3$color.r,
            _t17 = _r3$color.g,
            _i8 = _r3$color.b,
            _a4 = y.createSimpleFillSymbolJSON([_e21, _t17, _i8, null != s.symbols.fillOpacity ? s.symbols.fillOpacity <= 1 ? 255 * s.symbols.fillOpacity : s.symbols.fillOpacity : _r3.color.hasOwnProperty("a") ? _r3.color.a : 255], [_e21, _t17, _i8, null != s.symbols.outlineOpacity ? s.symbols.outlineOpacity <= 1 ? 255 * s.symbols.outlineOpacity : s.symbols.outlineOpacity : 255], 1);

        d.addUniqueValueInfo({
          value: _r3.classId,
          symbol: m.fromJSON(_a4)
        });
      }
    } catch (err) {
      _iterator24.e(err);
    } finally {
      _iterator24.f();
    }

    var c = a.map(function (e) {
      return d.getUniqueValueInfo(e).then(function (t) {
        e.symbol = t ? t.symbol : d.defaultSymbol;
      });
    });

    if (_this44.layer = new o({
      id: "".concat(e, "-polygon-features"),
      graphics: a,
      opacity: s.opacity,
      visible: !1
    }), Promise.all(c).then(function () {
      return _this44.layer.visible = !0;
    }), _this44.layerPromises.push(h(t, _this44.layer)), _this44.map.add(_this44.layer), !s.hideLabels && null != s.symbols.label) {
      if (0 === a.length) return _possibleConstructorReturn(_this44);
      var _e20 = s.symbols.label.field.name;
      if (!a[0].attributes.hasOwnProperty(_e20)) return _possibleConstructorReturn(_this44, void console.warn("PolygonFeatureLayer: Field '".concat(_e20, "' not found in feature attributes - skipping labeling...")));

      var _i6 = s.symbols.label.labelClass.symbol,
          _o2 = l.symbols.fields.labels.placementPrecision,
          _h3 = {
        placementPrecision: _o2,
        text: JSON.parse(JSON.stringify(_i6))
      },
          _d2 = [],
          fieldLabelMapFunction = function fieldLabelMapFunction(t) {
        return n.identifyLargestPolygonParts(t, _e20, "isLargestPolygon", !0);
      },
          _c = [];

      a.forEach(function (e) {
        var t = Q.getSimplifiedPolygonParts(e.geometry).map(function (t) {
          return new r({
            geometry: t,
            attributes: _objectSpread({}, e.attributes)
          });
        });

        _c.push.apply(_c, _toConsumableArray(t));
      });

      var _m = fieldLabelMapFunction(_c);

      var _iterator25 = _createForOfIteratorHelper(_m.values()),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _t15 = _step25.value;

          var _iterator26 = _createForOfIteratorHelper(_t15),
              _step26;

          try {
            for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
              var _s7 = _step26.value;

              var _t16 = _s7.attributes[_e20],
                  _i7 = n.getSingleLineLabelGraphic(_s7, _t16, _h3);

              _d2.push(_i7);
            }
          } catch (err) {
            _iterator26.e(err);
          } finally {
            _iterator26.f();
          }
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }

      var _y = _d2.filter(function (e) {
        return _this44.mapView.extent.intersects(e.geometry);
      });

      t.graphics.addMany(_y);
    }

    return _this44;
  }

  _createClass(PolygonLayer, [{
    key: "hide",
    value: function hide() {
      this.layer.visible = !1;
    }
  }], [{
    key: "featuresToPolygonFeatureGraphics",
    value: function featuresToPolygonFeatureGraphics(e) {
      var t = [];

      if (e) {
        e = PolygonLayer._validateFeatures(e);

        var _iterator27 = _createForOfIteratorHelper(e),
            _step27;

        try {
          var _loop7 = function _loop7() {
            var s = _step27.value;
            var e = "string" == typeof s.geometry ? X.wktToGeometry(s.geometry) : s.geometry,
                i = Q.getSimplifiedPolygonParts(e).map(function (e) {
              return new r({
                geometry: e,
                symbol: void 0,
                attributes: _objectSpread({}, s.attributes)
              });
            });
            t.push.apply(t, _toConsumableArray(i));
          };

          for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
            _loop7();
          }
        } catch (err) {
          _iterator27.e(err);
        } finally {
          _iterator27.f();
        }
      }

      return t;
    }
  }, {
    key: "_validateFeatures",
    value: function _validateFeatures(e) {
      if (e.length > 0 && null == e[0].attributes[Me.name]) {
        var _t18 = ke.find(function (t) {
          return null != e[0].attributes[t];
        }) || "";

        return e.forEach(function (e) {
          return e.attributes[Me.name] = e.attributes[_t18];
        }), e;
      }

      return e;
    }
  }]);

  return PolygonLayer;
}(BaseLayer);

var Ee = PolygonLayer,
    Je = _objectSpread({}, I),
    De = _objectSpread({}, O);

var SampleSitesLayer = /*#__PURE__*/function (_BaseLayer11) {
  _inherits(SampleSitesLayer, _BaseLayer11);

  var _super15 = _createSuper(SampleSitesLayer);

  function SampleSitesLayer(e, t, s) {
    var _this45;

    _classCallCheck(this, SampleSitesLayer);

    _this45 = _super15.call(this, e, t.map, t, s), _this45.layerPromises = [], _this45._fieldBoundaries = "[]", _this45._layerInfo = null, _this45._surfaceGuid = "", _this45._defaultSymbol = m.fromJSON(l.symbols.sampleSites.default), _this45._updateSamplingLayerLabelSequence = function (e, t) {
      e.clear();
      var s = 0,
          i = 0;
      t.sort(function (e, t) {
        return (e.attributes || {})[Je.sampleID] - (t.attributes || {})[Je.sampleID];
      }), t.forEach(function (t) {
        var a = (t.attributes || {})[Je.sampleID];
        a != s && (s = a, i = 0), i += 1, e.set((t.attributes || {}).PointGuid, i);
      });
    }, _this45._sampleLabelDisplaySequence = new Map(), _this45.id = e, _this45._isForImports = Boolean(s.isForImports), _this45._hideLabels = Boolean(s.hideLabels);
    var i = m.fromJSON(l.symbols.sampleSites.unmatched);
    _this45.renderer = new f({
      defaultSymbol: _this45._defaultSymbol,
      field: De.matched.name,
      uniqueValueInfos: [{
        value: "0",
        symbol: i
      }, {
        value: "1",
        symbol: _this45._defaultSymbol
      }]
    }), _this45._createLayer();
    return _this45;
  }

  _createClass(SampleSitesLayer, [{
    key: "_createLayer",
    value: function _createLayer() {
      this.layer = new o({
        id: this.id,
        graphics: [],
        minScale: l.layers.fields.minScale
      }), this.map.add(this.layer), this._hideLabels || (this.labelLayer = new o({
        id: "".concat(this.id, "_labels"),
        graphics: []
      }), this.labelLayer.minScale = l.layers.fields.minScale, this.map.add(this.labelLayer));
    }
  }, {
    key: "_setLabel",
    value: function _setLabel(e, t) {
      var _this46 = this;

      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (this._hideLabels) return;
      this.labelLayer.removeAll(), this._updateSamplingLayerLabelSequence(this._sampleLabelDisplaySequence, e);
      var i = e.map(function (e) {
        var i = m.fromJSON(s || l.symbols.sampleSites.label.text);

        var a = _this46._sampleLabelDisplaySequence.get(e.attributes.PointGuid);

        return i.text = "" === _this46._surfaceGuid ? t ? "".concat(e.attributes.SampleId, " - ").concat(a) : e.attributes.SampleId : e.attributes.Value, new r({
          geometry: e.geometry,
          symbol: i
        });
      });
      this.labelLayer.addMany(i);
    }
  }, {
    key: "_setSiteGraphics",
    value: function _setSiteGraphics(e, t, s) {
      var _this47 = this;

      return new Promise(function (i) {
        var a = e.map(function (e) {
          return _this47._setGraphic(e, t, s);
        });
        Promise.all(a).then(function () {
          i();
        });
      });
    }
  }, {
    key: "_setGraphic",
    value: function _setGraphic(e, t, s) {
      var _this48 = this;

      return new Promise(function (i, a) {
        try {
          var _a5 = X.wktToGeometry(e.shape);

          if (_a5.type === U.polygon) _a5 = _a5.centroid;else if (_a5.type !== U.point) return void i(e);

          if (0 === t.length || t.some(function (e) {
            return (e.geometry || e.shape).contains(_a5);
          })) {
            var _attributes;

            var _t19 = new r({
              geometry: _a5,
              attributes: (_attributes = {}, _defineProperty(_attributes, Je.sampleID, e.sampleId), _defineProperty(_attributes, Je.sequenceID, e.sequenceId), _defineProperty(_attributes, Je.matched, _this48._isForImports ? e.matched ? 1 : 0 : 1), _defineProperty(_attributes, "UUID", e[s]), _attributes)
            });

            _this48.renderer && "unique-value" === _this48.renderer.type && _this48.renderer.getUniqueValueInfo(_t19).then(function (s) {
              _t19.symbol = s ? s.symbol : _this48._defaultSymbol, _this48.layer.add(_t19), i(e);
            });
          } else i(e);
        } catch (o) {
          console.warn("Sample Site display error: ".concat(o.message)), i(e);
        }
      });
    }
  }, {
    key: "_setSites",
    value: function _setSites(e) {
      var _this49 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      this.layer && (this.show(), this._moveLayerToTop(this.layer), this.labelLayer && this._moveLayerToTop(this.labelLayer));
      var s = JSON.stringify(t);
      if (e === this._sampleSites && s === this._fieldBoundaries) return Promise.resolve();
      if (this._sampleSites = e, this._fieldBoundaries = s, this.clear(), 0 === e.length) return Promise.resolve();
      var i = e.some(function (e) {
        return void 0 !== e.eventSampleTissuePointGuid;
      }) ? z.TISSUE : z.SOIL;

      this._setSiteGraphics(e, t, i).then(function () {
        if (!_this49.layer) return Promise.resolve();
        var e = p.union(_this49.layer.graphics.map(function (e) {
          return e.geometry;
        }).toArray());

        if (_this49._hideLabels || _this49._setLabel(_this49.layer.graphics, !1), e) {
          var _t20 = e.extent;
          null != _t20 ? _this49.mapView.extent = _t20.expand(1.5) : e.type === U.point && (_this49.mapView.center = e, _this49.mapView.zoom = l.map.defaultZoomLevel);
        }

        return Promise.resolve();
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.layer ? (this.layer.removeAll(), this._layerInfo = null, this.labelLayer && this.labelLayer.removeAll(), Promise.resolve()) : Promise.resolve();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.layer.visible = !1, this.labelLayer && (this.labelLayer.visible = !1);
    }
  }, {
    key: "show",
    value: function show() {
      this.layer.visible = !0, this.labelLayer && (this.labelLayer.visible = !0);
    }
  }, {
    key: "setSites",
    value: function setSites(e, t) {
      var _this50 = this;

      return this._isForImports ? (t && this.options.getFieldBoundary(t).then(function (t) {
        return _this50._setSites(e, t);
      }), this._setSites(e)) : Promise.resolve();
    }
  }, {
    key: "update",
    value: function update(e) {
      var _this51 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      if (this._isForImports) return Promise.resolve(e);
      this.layer && (this.show(), this._moveLayerToTop(this.layer), this.labelLayer && this._moveLayerToTop(this.labelLayer));
      var o = e.agEventGeneralGuid;
      if (a.isEqual(this._layerInfo, e) && this._surfaceGuid === t && !r.length && !r.find(function (e) {
        return e.agEventGeneralGuid === o;
      })) return Promise.resolve(e);
      this._layerInfo = e, this._surfaceGuid = t;

      var fetchSampleSites$1 = function fetchSampleSites$1(e, t) {
        var s = _this51.options.formatNumber,
            i = Array.isArray(e) ? e : [e];
        return P(i, t).then(function (e) {
          if (null != s) {
            var _t21 = Math.min(2, e.reduce(function (e, t) {
              var s = t[Je.value];
              return Math.max(e, isNaN(s) || Math.floor(s) === s ? 0 : s.toString().split(".")[1].length || 0);
            }, 0)),
                _i9 = {
              minimumFractionDigits: _t21,
              maximumFractionDigits: _t21
            };

            var _iterator28 = _createForOfIteratorHelper(e),
                _step28;

            try {
              for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                var _a6 = _step28.value;
                var _e22 = _a6[Je.value];
                _e22 && (_a6[Je.value] = s(_e22, _i9));
              }
            } catch (err) {
              _iterator28.e(err);
            } finally {
              _iterator28.f();
            }
          }

          return e.map(N);
        });
      },
          fetchSampleSiteSequences$1 = function fetchSampleSiteSequences$1(e) {
        return T(e).then(function (e) {
          return e.map(V);
        });
      },
          l = function () {
        var e = null !== s ? [s] : [];
        return Array.isArray(o) ? t && Array.isArray(t) ? fetchSampleSites$1(t, e) : fetchSampleSiteSequences$1(o) : null === t || "" === t ? fetchSampleSiteSequences$1([o]) : fetchSampleSites$1(t, e);
      }();

      return new Promise(function (t, s) {
        l.then(function (s) {
          var a = _this51.renderer && "simple" === _this51.renderer.type ? _this51.renderer.symbol : _this51._defaultSymbol;
          s.forEach(function (e) {
            return e.symbol = a;
          });

          var r = s.some(function (e) {
            return s.some(function (t) {
              return t.attributes[Je.sampleID] === e.attributes[Je.sampleID] && e.attributes[Je.sequenceID] !== t.attributes[Je.sequenceID];
            });
          }),
              o = _objectSpread(_objectSpread({}, e), {}, {
            features: s
          });

          _this51.clear(), _this51._hideLabels || _this51._setLabel(s, r, i), _this51.layer.addMany(s), t(o);
        }).catch(function (e) {
          _this51._layerInfo = null, s(e), console.error("Error updating sample sites: ".concat(e.message));
        });
      });
    }
  }]);

  return SampleSitesLayer;
}(BaseLayer);

var Ce = {
  calculatedArea: "calculatedArea",
  densityRatingId: "densityRatingId",
  densityRatingName: "densityRatingName",
  objectId: "OBJECTID",
  observationName: "observationName",
  noIssuesFound: "noIssuesFound"
},
    $e = "label",
    Ue = "point",
    qe = "polygon";

var ScoutingObservationsLayer = /*#__PURE__*/function (_BaseLayer12) {
  _inherits(ScoutingObservationsLayer, _BaseLayer12);

  var _super16 = _createSuper(ScoutingObservationsLayer);

  function ScoutingObservationsLayer(e, t, s) {
    var _this52;

    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, ScoutingObservationsLayer);

    _this52 = _super16.call(this, e, t.map, t, s), _this52.layerInfo = null, _this52.surfaceGuid = "", _this52.layerPromises = [];

    var _ref7 = i || {},
        a = _ref7.points,
        r = _ref7.polygons;

    _this52.pointLayerId = "".concat(e, "-points"), _this52.polygonLayerId = "".concat(e, "-polygons"), _this52.polyLayer = new o({
      id: _this52.polygonLayerId,
      graphics: r || []
    }), _this52.layerPromises.push(h(t, _this52.polyLayer)), _this52.map.add(_this52.polyLayer), _this52.pointsLayer = new o({
      id: _this52.pointLayerId,
      graphics: a || []
    }), _this52.layerPromises.push(h(t, _this52.pointsLayer)), _this52.map.add(_this52.pointsLayer);
    return _this52;
  }

  _createClass(ScoutingObservationsLayer, [{
    key: "addObservations",
    value: function addObservations(e, t, s) {
      var _this53 = this;

      var i = ScoutingObservationsLayer.prepareObservationGraphics(e, t, this.options);

      if (this.pointsLayer.graphics.addMany(i.points.filter(function (e) {
        return "label" !== e.attributes[Ce.densityRatingId];
      })), this.polyLayer.graphics.addMany(i.polygons), !this.options.hideLabels) {
        var _e23 = [];
        i.points.forEach(function (s) {
          var i = "label" === s.attributes[Ce.densityRatingId] ? m.fromJSON(t.text.polygon) : m.fromJSON(t.text.point);
          i.text = s.attributes[Ce.observationName], _e23.push(new r({
            geometry: s.geometry.clone(),
            attributes: _objectSpread({}, s.attributes),
            symbol: i
          }));
        });

        var _a7 = _e23.filter(function (e) {
          return _this53.mapView.extent.intersects(e.geometry);
        });

        s.graphics.addMany(_a7);
      }
    }
  }], [{
    key: "prepareObservationGraphics",
    value: function prepareObservationGraphics(e, t, s) {
      if (0 === e.length) return {};
      var i = [],
          a = [];

      var _iterator29 = _createForOfIteratorHelper(e),
          _step29;

      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var _l2 = _step29.value;

          var _e24 = X.wktToGeometry(_l2.geometry);

          var _t22 = void 0;

          if (_l2.attributes.hasOwnProperty(Ce.calculatedArea) && "string" != typeof _l2.attributes[Ce.calculatedArea] && (_l2.attributes[Ce.calculatedArea] = String(_l2.attributes[Ce.calculatedArea])), _e24.type === qe) {
            if (_l2.attributes[Ce.noIssuesFound]) _t22 = m.fromJSON(s.symbols.none.polygon);else switch (_l2.attributes[Ce.densityRatingId]) {
              case s.symbols.heavy.value:
                _t22 = m.fromJSON(s.symbols.heavy.polygon);
                break;

              case s.symbols.light.value:
                _t22 = m.fromJSON(s.symbols.light.polygon);
                break;

              case s.symbols.moderate.value:
                _t22 = m.fromJSON(s.symbols.moderate.polygon);
                break;

              case s.symbols.none.value:
                _t22 = m.fromJSON(s.symbols.none.polygon);
                break;

              default:
                _t22 = m.fromJSON(s.symbols.default.polygon);
            }
            a.push(new r({
              geometry: _e24,
              attributes: _objectSpread({}, _l2.attributes),
              symbol: _t22
            })), i.push(new r({
              geometry: X.getPolyLabelPoint(_e24),
              attributes: _objectSpread(_objectSpread({}, _l2.attributes), {}, _defineProperty({}, Ce.densityRatingId, "label"))
            }));
          } else {
            if (_l2.attributes[Ce.noIssuesFound]) _t22 = m.fromJSON(s.symbols.none.point);else switch (_l2.attributes[Ce.densityRatingId]) {
              case s.symbols.heavy.value:
                _t22 = m.fromJSON(s.symbols.heavy.point);
                break;

              case s.symbols.light.value:
                _t22 = m.fromJSON(s.symbols.light.point);
                break;

              case s.symbols.moderate.value:
                _t22 = m.fromJSON(s.symbols.moderate.point);
                break;

              case s.symbols.none.value:
                _t22 = m.fromJSON(s.symbols.none.point);
                break;

              default:
                _t22 = m.fromJSON(s.symbols.default.point);
            }
            i.push(new r({
              geometry: _e24,
              attributes: _objectSpread({}, _l2.attributes),
              symbol: _t22
            }));
          }
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }

      var o = new Map();
      o.set(t.heavy.value, t.heavy.weight), o.set(t.light.value, t.light.weight), o.set(t.moderate.value, t.moderate.weight), o.set(t.none.value, t.none.weight);

      var sortBy = function sortBy(e, t) {
        var s = e.attributes[Ce.calculatedArea],
            i = t.attributes[Ce.calculatedArea];
        if (s > i) return -1;
        if (s < i) return 1;
        {
          var _s8 = o.get(e.attributes[Ce.densityRatingId]),
              _i10 = o.get(t.attributes[Ce.densityRatingId]);

          return null == _s8 || _s8 < _i10 ? -1 : null == _i10 || _s8 > _i10 ? 1 : 0;
        }
      };

      a.sort(sortBy), i.sort(sortBy);

      var combineNames = function combineNames(e, t) {
        var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        var i = new Set(e.attributes[Ce.observationName].split(","));

        var _iterator30 = _createForOfIteratorHelper(t.attributes[Ce.observationName].split(",")),
            _step30;

        try {
          for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
            var _o3 = _step30.value;
            i.add(_o3.replace("Site-", ""));
          }
        } catch (err) {
          _iterator30.e(err);
        } finally {
          _iterator30.f();
        }

        var a = Array.from(i.values()).filter(function (e) {
          return null != e && e.length > 0;
        });
        a.sort(function (e, t) {
          return Number(e) - Number(t);
        });
        var r = a.join(",");
        e.attributes[Ce.observationName] = r, t.attributes[Ce.observationName] = s ? r : "";
      },
          clusterNames = function clusterNames(e) {
        var s = [];

        var _iterator31 = _createForOfIteratorHelper(e.entries()),
            _step31;

        try {
          for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
            var _step31$value = _slicedToArray(_step31.value, 2),
                _i11 = _step31$value[0],
                _a8 = _step31$value[1];

            for (var _r4 = _i11 + 1; _r4 < e.length; _r4++) {
              var _i12 = e[_r4];

              var _l = !1;

              if (X.areEqual(_a8.geometry, _i12.geometry)) {
                _l = o.get(_a8.attributes[Ce.densityRatingId]) < o.get(_i12.attributes[Ce.densityRatingId]), s.push(_l ? _a8 : _i12);
              }

              var _n2 = D.geographicToWebMercator(_a8.geometry.type === Ue ? _a8.geometry : X.getPolyLabelPoint(_a8.geometry)),
                  _h4 = D.geographicToWebMercator(_i12.geometry.type === Ue ? _i12.geometry : X.getPolyLabelPoint(_i12.geometry));

              p.distance(_n2, _h4, "meters") <= t.clusterLabelingMeters && combineNames(_a8, _i12, _l);
            }

            _a8.attributes[Ce.observationName].length > 0 && (_a8.attributes[Ce.observationName] = "Site-".concat(_a8.attributes[Ce.observationName]));
          }
        } catch (err) {
          _iterator31.e(err);
        } finally {
          _iterator31.f();
        }

        return e.filter(function (e) {
          return !s.includes(e);
        });
      };

      return a = clusterNames(a), i = clusterNames(i), {
        polygons: a,
        points: i
      };
    }
  }]);

  return ScoutingObservationsLayer;
}(BaseLayer);

var ze = E,
    We = {
  FeatureLayer: 0,
  CanvasLayer: 1,
  RasterLayer: 2,
  parse: function parse(e, t) {
    return /points/i.test(e) ? We.CanvasLayer : /coverage/i.test(e) || /imagery/i.test(e) && (!t || t.length < 1) ? We.RasterLayer : We.FeatureLayer;
  }
};

var SurfaceLayer = /*#__PURE__*/function (_BaseLayer13) {
  _inherits(SurfaceLayer, _BaseLayer13);

  var _super17 = _createSuper(SurfaceLayer);

  function SurfaceLayer(e, t, s) {
    var _this54;

    _classCallCheck(this, SurfaceLayer);

    _this54 = _super17.call(this, e, t.map, t, s), _this54.isInvalid = !1, _this54.surfaceInfo = "", _this54.minScale = l.layers.fields.minScale, _this54.layerBoundary = new o({
      id: "".concat(e, "_Boundary"),
      graphics: [],
      minScale: _this54.minScale
    }), _this54.map.layers.add(_this54.layerBoundary), _this54.fieldGuid = s.fieldGuid, s.bypassBoundaryFetch || _this54.setFieldBoundary(_this54.fieldGuid);
    return _this54;
  }

  _createClass(SurfaceLayer, [{
    key: "_createLayer",
    value: function _createLayer(e, t) {
      var _this55 = this;

      var s = t.map(function (t) {
        return e.getUniqueValueInfo(t).then(function (e) {
          t.symbol = e ? e.symbol : null;
        });
      });

      if (null == this.layer) {
        this.layer = new o({
          id: this.id,
          minScale: this.minScale,
          graphics: t,
          visible: !1
        });

        var _e25 = this.map.layers.findIndex(function (e) {
          return e.id === W.MEASURE_GRAPHICS_LAYER;
        });

        _e25 <= 0 && (_e25 = this.map.layers.length), this.map.add(this.layer, _e25), this.moveLayerBoundaryAboveSurface(), Promise.all(s).then(function () {
          return _this55.layer.visible = !0;
        });
      } else this.layer.removeAll(), Promise.all(s).then(function () {
        return _this55.layer.addMany(t);
      });
    }
  }, {
    key: "_createCoverageLayer",
    value: function _createCoverageLayer(e, t) {
      var s = new c({
        x: e.xmin,
        y: e.ymax,
        spatialReference: {
          wkid: 3857
        }
      }),
          i = new c({
        x: e.xmax,
        y: e.ymin,
        spatialReference: {
          wkid: 3857
        }
      });
      this.rasterLayer = new BigDataLayer("CoverageRaster", this.mapView, _objectSpread(_objectSpread({}, this.options), {}, {
        imageOptions: {
          url: t,
          topLeft: s,
          bottomRight: i
        }
      })), this.moveLayerBoundaryAboveSurface();
    }
  }, {
    key: "_showLayers",
    value: function _showLayers(e) {
      switch (this.hide(), e) {
        case We.CanvasLayer:
          this.canvasLayer || (this.canvasLayer = new BigDataLayer("SurfPnts_".concat(this.mapView.container, "_").concat(this.fieldGuid), this.mapView, _objectSpread(_objectSpread({}, this.options), {}, {
            rendererOptions: u.getCanvasRendererOptions()
          }))), this.canvasLayer.setVisibility(!0);
          break;

        case We.FeatureLayer:
          this.layer && (this.layer.visible = !0);
          break;

        case We.RasterLayer:
          this.rasterLayer && this.rasterLayer.setVisibility(!0);
      }

      this.layerBoundary.visible = !0;
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.canvasLayer && this.canvasLayer.clear(), this.rasterLayer && this.rasterLayer.clear(), this.layer && this.layer.removeAll(), this.surfaceInfo = null, Promise.resolve();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.canvasLayer && this.canvasLayer.setVisibility(!1), this.rasterLayer && this.rasterLayer.setVisibility(!1), this.layer && (this.layer.visible = !1), this.layerBoundary.visible = !1;
    }
  }, {
    key: "moveLayerBoundaryAboveSurface",
    value: function moveLayerBoundaryAboveSurface() {
      this.layer && this.layerBoundary && (this._moveLayerToTop(this.layerBoundary), this.moveLayerToBottom(this.layer));
    }
  }, {
    key: "setFieldBoundary",
    value: function setFieldBoundary(e) {
      var _this56 = this;

      this.layerBoundary.removeAll(), B([e], null, null, !0).then(function (e) {
        var t = e.map(x);

        var _iterator32 = _createForOfIteratorHelper(t),
            _step32;

        try {
          for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
            var _s9 = _step32.value;
            _s9.symbol = m.fromJSON(l.symbols.fields.transparent), _this56.layerBoundary.graphics.add(_s9);
          }
        } catch (err) {
          _iterator32.e(err);
        } finally {
          _iterator32.f();
        }
      });
    }
  }, {
    key: "setFieldBoundaryFeatures",
    value: function setFieldBoundaryFeatures(e) {
      this.layerBoundary.removeAll();
      var t = [];

      var _iterator33 = _createForOfIteratorHelper(e),
          _step33;

      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var _s10 = _step33.value;
          _s10.symbol = m.fromJSON(l.symbols.fields.transparent), t.push(_s10);
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }

      this.layerBoundary.addMany(t);
    }
  }, {
    key: "update",
    value: function update(e) {
      var _this57 = this;

      var t;
      this.isInvalid && (this.setFieldBoundary(this.fieldGuid), this.isInvalid = !1);
      var s = We.parse(e.surfaceType, e.classBreaks);

      this._showLayers(s);

      var i = Promise.resolve(e);
      if (ae(this.surfaceInfo, e)) return i;
      this.clear(), this.surfaceInfo = e;
      var a = e.classBreaks,
          o = e.rendererGuid;

      switch (s) {
        case We.CanvasLayer:
          this.canvasLayer.setRenderer(u.getCanvasRendererOptions(a)), i = M(this.userGuid, e, this.fieldGuid).then(function (_ref8) {
            var t = _ref8.pointData;
            return _this57.canvasLayer.setData(t.map(function (e) {
              var _D$lngLatToXY = D.lngLatToXY(parseFloat(e.x), parseFloat(e.y)),
                  _D$lngLatToXY2 = _slicedToArray(_D$lngLatToXY, 2),
                  t = _D$lngLatToXY2[0],
                  s = _D$lngLatToXY2[1];

              return {
                geometry: {
                  x: t,
                  y: s
                },
                value: e.value
              };
            })), e;
          });
          break;

        case We.FeatureLayer:
          {
            var _t23 = n.createUniqueValueRenderer(ze.class, a);

            i = R(o).then(function (s) {
              var i = [];

              var _iterator34 = _createForOfIteratorHelper(s),
                  _step34;

              try {
                var _loop8 = function _loop8() {
                  var e = _step34.value;
                  var t = k(e),
                      s = Q.getSimplifiedPolygonParts(t.geometry).map(function (e) {
                    return new r({
                      geometry: e,
                      attributes: _objectSpread({}, t.attributes)
                    });
                  });
                  i.push.apply(i, _toConsumableArray(s));
                };

                for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
                  _loop8();
                }
              } catch (err) {
                _iterator34.e(err);
              } finally {
                _iterator34.f();
              }

              return _this57._createLayer(_t23, i), e;
            });
            break;
          }

        case We.RasterLayer:
          {
            var _s11 = {
              surfaceRendererGuid: o,
              surfaceTypeName: null === (t = e.surfaceType) || void 0 === t ? void 0 : t.toLowerCase()
            };
            i = A(this.userGuid, _s11).then(function (t) {
              var s = t.extent,
                  i = t.href;
              return _this57._createCoverageLayer(s, i), e;
            }).catch(function (t) {
              console.warn(t);
              var _this57$options = _this57.options,
                  s = _this57$options.messages,
                  i = _this57$options.onPushToasterMessage;
              return i(s.failedToLoadSurface, H.ERROR), e;
            });
            break;
          }
      }

      return i;
    }
  }]);

  return SurfaceLayer;
}(BaseLayer);

export { BaseLayer as B, ue as C, DggLayer as D, FieldBoundaryImportLayer as F, pe as I, LegacyCanvasLayer as L, MultiFieldImageryLayer as M, NonFieldFeaturesLayer as N, PolygonLayer as P, StoredLayer as S, TileLayer as T, fe as a, BigDataLayer as b, CanvasLayerSimpleUVR as c, FieldBoundaryApiAspect as d, FieldsLayer as e, ImportDataConvexHullLayer as f, MultiLayer as g, StoredItem as h, Ee as i, SampleSitesLayer as j, Ce as k, $e as l, ScoutingObservationsLayer as m, We as n, SurfaceLayer as o, ImageryTileLayer as p };